const ORDER_STATUS_BID = "bid";
const ORDER_STATUS_ORDERED = "ordered";
const ORDER_STATUS_VERIFIED = "verified";

(() => {
  if (typeof MoxForm === 'undefined' || typeof MoxForm.Go !== 'function' || MoxForm.__cfValidationHooked) return;
  const origGo = MoxForm.Go;
  MoxForm.Go = (form, extra_validation, prevent_submit, elementToIgnore) => {
    const wrapped = (mox) => {
      document.querySelectorAll('input[name^="custom["].required').forEach((cfInput) => {
        mox.require(cfInput.id, get_language_translation('REQUIRED_FIELD_LANG'));
      });
      const result = (typeof extra_validation === 'function') ? extra_validation(mox) : undefined;
      if (mox.failed && result === 0 && typeof show_order_error_modal === 'function') {
        show_order_error_modal();
      }
      return result;
    };
    return origGo(form, wrapped, prevent_submit, elementToIgnore);
  };
  MoxForm.__cfValidationHooked = true;

  if (typeof get_rightside === 'function' && !get_rightside.__cfHooked) {
    const origGetRightside = get_rightside;
    window.get_rightside = (mox) => {
      if (mox && mox.failed) return;
      return origGetRightside(mox);
    };
    window.get_rightside.__cfHooked = true;
  }
})();

var OrderAddress = Class.create({
  initialize: function (addressType) {
    this.addressType = addressType;
    if ((this.toggler = $(this.addressType + "_same_as_billing"))) {
      this.toggleToSameAs();
      this.toggler.observe(
        "click",
        this.toggleToSameAs.bindAsEventListener(this)
      );
    }
    if ($("existing_" + this.addressType)) {
      var UseAnExistingAddress = $("existing_" + this.addressType);
      UseAnExistingAddress.observe(
        "change",
        this.observeUseAnExistingAddress.bindAsEventListener(this)
      );
      this.observeUseAnExistingAddress({
        element: function () {
          return UseAnExistingAddress;
        },
        no_clear: true,
      });
    }

    am.$(document).on(
      "click",
      ".am-alert--dismissible .btn-close",
      function () {
        am.$(this).parent().clearQueue().fadeOut();
      }
    );
  },

  toggleToSameAs: function () {
    $(this.addressType + "_hideable")[this.toggler.checked ? "hide" : "show"]();
  },

  observeUseAnExistingAddress: function (event) {
    var value = $F(event.element());
    if (value && value.isJSON()) {
      var json = value.evalJSON();
      if (json.country != $(this.addressType + "_country")) {
        Form.Element.setValue(this.addressType + "_country", json.country);
        update_states_on_country_change({
          name: this.addressType + "_name",
          nameval: json.name,
          state_id: this.addressType + "_state",
          country_id: this.addressType + "_country",
          state_name: this.addressType + "[state]",
          zip_id: this.addressType + "_zip",
          set_state: json.state
        });
      }
      Object.keys(json).each(
        function (key) {
          if ((element = $(this.addressType + "_" + key))) {
            Form.Element.setValue(element, json[key]);
          }
        }.bind(this)
      );

      // Calculate Shipping Price
      if (theOrder)
        // is undefined the first time this is called on logged-in customer view of page orders/new/
        theOrder.invalidate("shipping").invalidate("tax_rate").process();
    } else {
      if (event.no_clear != true) clear_addresses(this.addressType);
    }
  },
});

var SupplyAllocationTable = Class.create({
  initialize: function (element, options) {
    this.rows = new Hash();
    this.options = {};
    Object.extend(this.options, options);
    this.element = $(element);
    this.tbody = this.element.down("tbody");
    GUI.templatize("new_row_template"); // this prepares the template
    this.element
      .up()
      .select(".add_row")
      .each(
        function (element) {
          element.observe(
            "click",
            function (event) {
              event.stop();
              this.addRow();
            }.bindAsEventListener(this)
          );
        }.bind(this)
      );
    this.tbody.delegate(
      ".delete_icon",
      "click",
      function (event) {
        event.stop();
        this.deleteRow(event.element());
      }.bindAsEventListener(this)
    );
    this.tbody.childElements().each(
      function (tr) {
        this.rows.set(tr.identify(), new SupplyAllocationRow(tr, this));
      }.bind(this)
    );
    if (!this.tbody.childElements().length) {
      this.addRow();
    }
  },
  addRow: function () {
    GUI.enumerate(GUI.templates["new_row_template"], this.tbody.identify());
    this.rows.set(
      this.tbody.childElements().last().identify(),
      new SupplyAllocationRow(this.tbody.childElements().last(), this)
    );
  },

  deleteRow: function (element) {
    if ("TR" != element.tagName.toUpperCase()) element = element.up("tr");
    this.rows.unset($(element).id);
    $(element).remove();
  },
});
var SupplyAllocationRow = Class.create({
  initialize: function (element, parentSupplyAllocationTable) {
    this.locationAndItem = {};
    this.parentSupplyAllocationTable = parentSupplyAllocationTable;
    this.element = $(element);
    if ((this.location_select = this.element.down("select.location_select"))) {
      this.location_select.observe(
        "change",
        function (event) {
          event.stop();
          this.locationAndItem.location =
            this.location_select.options[
              this.location_select.selectedIndex
            ].value;
          delete this.locationAndItem.item;
          GUI.select_location(
            this.location_select,
            false,
            this.filter_ils.bind(this)
          );
        }.bindAsEventListener(this)
      );

      this.item_select = this.element.down("select.item_select");
      this.item_select.observe(
        "change",
        function (event) {
          event.stop();
          GUI.select_item(this.item_select);
          this.locationAndItem.item =
            this.item_select.options[
              this.item_select.selectedIndex
            ].readAttribute("rel");
        }.bindAsEventListener(this)
      );
    } else {
      var tempObject = this.element.id.sub("supply_", "").split(".");
      this.locationAndItem = { location: tempObject[0], item: tempObject[1] };
    }
  },

  filter_ils: function (select) {
    var optionsToDisable = new Array();
    this.parentSupplyAllocationTable.rows.each(
      function (sar) {
        if (
          sar.value.locationAndItem &&
          sar.value.locationAndItem.item &&
          sar.value.locationAndItem.location == this.locationAndItem.location
        ) {
          optionsToDisable.push(sar.value.locationAndItem.item);
        }
      }.bind(this)
    );
    $(select)
      .select("option")
      .each(function (option) {
        if (optionsToDisable.include(option.readAttribute("rel"))) {
          option.disabled = true;
          option.writeAttribute({
            title:
              get_language_translation(
                "LANG_YOU_CANNOT_SEL_THIS_ITEM_BECAUSE_IT_IS_ALREADY_ON_THE_PAGE"
              ) + ".",
          });
        }
      });
    return select;
  },
});

function all_togglers() {
  Sortable.create("componentset", { tag: "div", handle: "dh" });
  Sortable.create("productset", { tag: "div", handle: "dh" });
  Sortable.create("supplyset", { tag: "div", handle: "dh" });
  verify_component_togglers();
}

function verify_component_togglers(container) {
  container = container === undefined ? "componentset" : container;

  if ($(container)) {
    let $obj;
    if (container === "componentset" && am.$(".componentset").length > 1) {
      $obj = am.$(".componentset");
    } else {
      $obj = am.$("#" + container);
    }
    $obj.find(".component").each(function (_, component) {
      if (component.observed) return;
      component.observed = true;
      am.$(component)
        .find(".toggler")
        .each(function (_, toggler) {
          am.$(toggler).on("click", function (ev) {
            component_toggler(ev, toggler);
          });
        });
    });
  }
}
function component_toggler(ev, clicked, options) {
  var collapsible = clicked.up().down(".collapsible");
  if (!collapsible) {
    collapsible = clicked.up(".collapsible");
  }
  const $collapsible = am.$(collapsible);

  options = Object.extend(
    { duration: 0.2, queue: { position: "end", scope: collapsible.id } },
    options
  );
  ev.stopPropagation();
  if ("Edit Details" === clicked.innerHTML) {
    clicked.addClassName("close").removeClassName("open").innerHTML =
      "Hide Details";
    Effect.BlindDown(collapsible, options);
  } else {
    clicked.addClassName("open").removeClassName("close").innerHTML =
      "Edit Details";
    Effect.BlindUp(collapsible, options);
  }

  if (clicked.parentElement === collapsible) {
    $collapsible
      .parent()
      .find(".toggler.close")
      .removeClass("close")
      .addClass("open")
      .text("Edit Details");
  } else {
    $collapsible
      .find(".toggler.open")
      .removeClass("open")
      .addClass("close")
      .text("Hide Details");
  }
}
function toggle_section(section) {
  if ($(section + "_section").visible()) {
    $(section + "_header")
      .removeClassName("opened")
      .addClassName("closed")
      .insert($(section + "_total_section"));
    $(section + "_section").hide();
    if ($(section + "_header").down("input")) {
      var ob = $(section + "_header").down("input");
      ob.remove();
    }
  } else {
    $(section + "_header")
      .removeClassName("closed")
      .addClassName("opened")
      .insert(
        new Element("input", {
          type: "hidden",
          name: "open[" + section + "]",
          value: "1",
        })
      );
    $(section + "_section")
      .show()
      .down(".total_section_holder")
      .insert($(section + "_total_section"));
  }
}
function order_job_submit(o) {
  o.insert({
    after: new Element("input", {
      type: "hidden",
      name: "status",
      value: "ordered",
    }),
  });
  return MoxForm.Go(o, continue_submit);
}
function isJQuery(obj) {
  return obj !== undefined && obj !== null && obj.jquery !== undefined;
}
function get_product_image(ob, site) {
  // We have a blend of what ob is being passesd as eg.(dom element || jquery $element )
  if (isJQuery(ob))
    // Check if ob is jquery
    ob = ob[0]; // get the dom element from the object

  var img = ob.up(".pao_td").down("div.pao_pic");
  if (!img) return;
  if (!ob.select("option").length) return;
  var flnm = ob.down("option:selected").getAttribute("rel");
  var b2b_base = (ob.down("option:selected")?.getAttribute("data-b2b-base") || "").trim();
  if (b2b_base) b2b_base = b2b_base.replace(/\/?$/, "/");
  var flnm_text = ob.down("option:selected").innerHTML;
  var rel_id = ob
    .up(".pao_td")
    .down(".pao_bottom")
    .down("select")
    .getAttribute("name")
    .replace(/(\[)/g, "_")
    .replace(/(\])+/g, "");
  var rel = "lightbox[" + rel_id + "]";
  var options = ob.select("option");
  // DEV-13574: lazy selects render only the saved option, and the full list arrives
  // later (products.js loadLazySelectOptions -> refreshProductImageFor). The links
  // were built once, so every late option had none and clicking its image did
  // nothing. Rebuild whenever the option list (or the select's rel) changes.
  var jextraKey =
    rel +
    "|" +
    options
      .map(function (elem) {
        return elem.getAttribute("rel") || "";
      })
      .join("|");
  if (img.getAttribute("data-jextra_key") !== jextraKey) {
    img.select("a.jextra").invoke("remove");
    img.setAttribute("data-jextra_key", jextraKey);
    options.each(function (elem) {
      var flnm2 = elem.getAttribute("rel");

      if (flnm2 != null && flnm2.length && flnm2.indexOf(".default") >= 0) {
        img.insert(
          "<a class='jextra' title='" +
            html_safe(elem.innerHTML) +
            "' href='https://cdn.allmoxy.com/brading/default_transparant.png' rel='" +
            rel +
            "' style='display:none;'></a>"
        );
      } else if (site) {
        if (flnm2 != null && flnm2.length && flnm2.indexOf(".default") == -1) {
          img.insert(
            "<a class='jextra' title='" +
              html_safe(elem.innerHTML) +
              "' href='" +
              site +
              "data/catalog/pao/big/" +
              elem.getAttribute("rel") +
              "' rel='" +
              rel +
              "' style='display:none;'></a>"
          );
        } else {
          img.insert(
            "<a class='jextra' title='" +
              html_safe(elem.innerHTML) +
              "' href='https://cdn.allmoxy.com/brading/default_transparant.png' rel='" +
              rel +
              "' style='display:none;'></a>"
          );
        }
      } else {
        if (flnm2 != null && flnm2.length && flnm2.indexOf(".default") == -1) {
          img.insert(
            "<a class='jextra' title='" +
              html_safe(elem.innerHTML) +
              "' href='/data/catalog/pao/big/" +
              elem.getAttribute("rel") +
              "' rel='" +
              rel +
              "' style='display:none;'></a>"
          );
        } else {
          img.insert(
            "<a class='jextra' title='" +
              html_safe(elem.innerHTML) +
              "' href='https://cdn.allmoxy.com/brading/default_transparant.png' rel='" +
              rel +
              "' style='display:none;'></a>"
          );
        }
      }
    });
  }
  // Exact filename match: a substring test showed "11.png"'s link for "1.png" too.
  img.select("a.jextra").select(function (a) {
    var href = a.getAttribute("href") || "";
    if (flnm && flnm.length && href.slice(-(flnm.length + 1)) === "/" + flnm)
      a.style.display = "block";
    else a.style.display = "none";
  });
  if (flnm != null && flnm.length && flnm.indexOf(".default") >= 0) {
    img.setStyle({
      backgroundImage:
        "url(https://cdn.allmoxy.com/brading/default_transparant.png)",
    });
  } else if (site) {
    if (flnm === null || !flnm.length) {
      img.setStyle({
        backgroundImage:
          "url(https://cdn.allmoxy.com/brading/default_transparant.png)",
      });
    } else {
      img.setStyle({
        backgroundImage: "url('" + site + "data/catalog/pao/big/" + flnm + "')",
      });
    }
  } else {
    if (flnm === null || !flnm.length) {
      img.setStyle({
        backgroundImage:
          "url(https://cdn.allmoxy.com/brading/default_transparant.png)",
      });
    } else {
      img.setStyle({
        backgroundImage: "url('" + b2b_base + "data/catalog/pao/big/" + flnm + "')",
      });
    }
  }

  // DEV-12912: an imageless selection renders the certified empty slot (dashed
  // outline-variant + the value's name, styled in m3/_field.scss) instead of an
  // invisible transparent PNG. The sentinel URLs above stay untouched — litebox
  // keys on them; this only classifies the slot.
  var noImage = flnm == null || !flnm.length || flnm.indexOf(".default") >= 0;
  var emptyLabel = (function () {
    var optEl = ob.down("option:selected");
    return ((optEl && optEl.textContent) || "").trim();
  })();
  if (noImage) {
    img.classList.add("pao_pic--noimg");
    img.setAttribute("data-empty-label", emptyLabel);
  } else {
    img.classList.remove("pao_pic--noimg");
    img.removeAttribute("data-empty-label");
    // The option CLAIMS an image, but a CSS background that 404s renders
    // nothing — an invisible void (DB row without a media file, common on
    // dev-line data). Probe the real file; on failure fall back to the empty
    // slot. The guard re-checks the slot still shows THIS url so a late
    // probe from a superseded selection can't misclassify the current one.
    var probeUrl = (site ? site : b2b_base) + "data/catalog/pao/big/" + flnm;
    var probe = new Image();
    probe.onerror = function () {
      if ((img.style.backgroundImage || "").indexOf(flnm) === -1) return;
      img.classList.add("pao_pic--noimg");
      img.setAttribute("data-empty-label", emptyLabel);
    };
    probe.src = probeUrl;
  }

  am.$(img)
    .find("[data-litebox_initialized]")
    .removeAttr("data-litebox_initialized");
  if (initLightbox.myLightbox) {
    initLightbox.myLightbox.initialize_more(img);
  }
}

get_quantity = Object.extend(
  function (set) {
    if ("componentset" == set) return get_quantity.component();
    var total = 0;
    $$("#" + set + " .qty").each(function (el) {
      if ($F(el).length) total += parseInt($F(el));
    });
    return total;
  },
  {
    component: function () {
      var total = 0;
      $("componentset")
        .select(".component")
        .each(function (component) {
          var c_total = 0;
          component.select(".product .qty").each(function (el) {
            if ($F(el).length) c_total += parseInt($F(el));
          });
          total += c_total * cur2num(component.down(".qty").value);
        });
      return total;
    },
  }
);

get_quantity_by_instance = Object.extend(
  function (set, folder_id) {
    const folder_selector = folder_id ? "#" + folder_id : "";
    const set_selector = folder_selector + " #" + set; // #folder_123 #componentset or #componentset

    if (
      ("componentset" === set || "cart_product" === set) &&
      am.$(set_selector).find(".component").length > 0
    ) {
      return get_quantity_by_instance.component(set, folder_id);
    }

    var total = {};

    $$(folder_selector + " #" + set + " .qty").each(function (el) {
      let instance;
      if (theOrder?.isTypeProject()) {
        instance = 'LOCAL';
      } else {
        instance = el.up(".product").getAttribute("data-rsource"); // is NULL when attribute not defined
      }
      if ($F(el).length) {
        if (!total.hasOwnProperty(instance)) total[instance] = 0;
        total[instance] += parseInt($F(el));
      } else if (!total[instance]) total[instance] = 0;
    });
    return total;
  },
  {
    component: function (set, folder_id) {
      var total = {};
      const folder_selector = folder_id ? "#" + folder_id : "";
      $$(folder_selector + " #" + set + " .component").each(function (
        component
      ) {
        var c_total = 0;
        component.select(".product .qty").each(function (el) {
          if ($F(el).length) c_total += parseInt($F(el));
        });
        var instance = component.getAttribute("data-rsource");
        if (!total.hasOwnProperty(instance)) total[instance] = 0;
        total[instance] += c_total * cur2num(component.down(".qty").value);
      });
      return total;
    },
  }
);

function careful_jobs_margin(s, e) {
  if (!e) e = window.event;
  switch (
    e.keyCode // don't respond to tab, shift, ctrl, alt, etc.
  ) {
    case 9:
    case 16:
    case 17:
    case 18:
    case 20:
    case 37:
    case 38:
    case 39:
    case 40:
    case 45:
    case 91:
    case 93:
    case 144:
      return;
  }
  jobs_margin(s);
}
function jobs_margin(s) {
  if (s === undefined)
    return console.log("Depreciated function call to jobs_margin");
  var ids = ["gt_markup", "gt_profit", "pre_tax_price"];
  $("gt_profit").addClassName("gray");
  $("gt_markup").addClassName("gray");
  $("pre_tax_price").addClassName("gray");
  $(ids[s]).removeClassName("gray");
  theOrder.invalidate("tax").process();
}
function shipping_method_changed() {
  if (!$("allocation_form") && !$("production_form")) {
    show_hide_shipping();
    if ($("shipping_override")) {
      if ($("back_to_auto")) {
        $("back_to_auto").replace("");
        $("shipping_override")
          .up()
          .replace(
            "<a href='javascript:void(0);' id='shipping' onclick='return edit_shipping_price(this)'>-</a>"
          );
      }
    } else {
      if (theOrder) {
        theOrder.invalidate("tax_rate").invalidate("shipping");
        if (!theOrder.requester || theOrder.requester.transport.readyState == 4)
          theOrder.process();
      }
    }
  }
  //theOrder.invalidate('shipping').process_without_items();
  else {
    theOrder?.invalidate("shipping").process();
  }
}
function show_hide_shipping() {
  if (document.getElementById("shipping_container")) {
    var show_shipping = false;
    $$("select.shipping_method").each(function (el) {
      var selectedOption = el.options[el.selectedIndex];
      var isActAsWillCall = selectedOption.getAttribute("data-act-as-will-call") == "1";
      if (selectedOption.value != 0 && !isActAsWillCall) {
        show_shipping = true;
        return false;
      }
    });
    if (!show_shipping) {
      $("shipping_container").hide();
      $("shipping_container")
        .nextSiblings()
        .select(function (el) {
          return el.hasClassName("validation-advice");
        })
        .invoke("hide");
      $$(".error > div")
        .select(function (el) {
          return el.id.startsWith("_shipping");
        })
        .invoke("hide");
    } else $("shipping_container").show();
  }
}
function validate_product_field(id) {
  if (!$(id) || !$(id).getAttribute("onvalidate")) return true;
  var field = frac_to_dec($F(id));
  if (!Number(field)) return false;
  return eval($(id).getAttribute("onvalidate"));
}

function addCosts(where) {
  var date = new Date();
  var id = Date.parse(date) + Math.floor(Math.random() * 1000);
  var html =
    "<tr id='c" +
    id +
    "'>" +
    "	<td class='first nowrap' colspan='2' style='width:100%'><input type='text' class='text' id='cost_name_" +
    id +
    "' name='cost[n" +
    id +
    "][name]' value='' style='text-align:left'/></td>" +
    "	<td class='nowrap'>" +
    get_currency_symbol() +
    "<input class='text costs currency' onblur='this.value=number_format(cur2num(this.value),2)' id='cost_" +
    id +
    "' name='cost[n" +
    id +
    "][price]' value='' type='text'/></td>" +
    "   <td class='nowrap center-checkbox'><label class='inline nml'><input type='checkbox' class='cb2 is_taxable_cost' id='cost_is_taxable_" +
    id +
    "' name='cost[n" +
    id +
    "][is_taxable]' value='1'/><span></span></label></td>" +
    "	<td class='last'><a href='' onclick='return remove_cost_row(this)'><i class='fa fa-trash'></i> </a></td>" +
    "</tr>";
  where.insert(html);
  return false;
}

function validateProjectOrderLineItems() {
  const quotePane = document.querySelector('[data-tab-pane="quote"]');
  if (quotePane && quotePane.style.display === "none") {
    return 0;
  }

  let invalidItems = 0;
  document.querySelectorAll(".project-line-items table tbody tr").forEach(tr => {
    const $description = tr.querySelector(".description");
    const $price = tr.querySelector(".price");
    const $qty = tr.querySelector(".qty");

    const description = ($description?.value || "").trim();
    const price = parseFloat($price?.value);
    const qty = parseInt($qty?.value ?? 1);

    const isUntouchedDefaultRow =
      tr.dataset.defaultRow === "1" &&
      description === "" &&
      ($price?.value || "").trim() === "" &&
      ($qty?.value || "").trim() === "";

    if (isUntouchedDefaultRow) {
      $description?.classList.remove("am-error-border");
      $price?.classList.remove("am-error-border");
      $qty?.classList.remove("am-error-border");
      return;
    }

    const invalidDescription = description === "";
    const invalidPrice = isNaN(price);
    const invalidQty = isNaN(qty) || qty <= 0;

    $description?.classList.toggle("am-error-border", invalidDescription);
    $price?.classList.toggle("am-error-border", invalidPrice);
    $qty?.classList.toggle("am-error-border", invalidQty);

    if (invalidDescription || invalidPrice || invalidQty) {
      invalidItems++;
    }
  });
  return invalidItems;
}

function allowToSaveBidWithValidationErrorsEnabled() {
  return (
    document.querySelector("#allow_save_bids_with_errors")?.value.toString() ===
    "1"
  );
}

var warned_cust = 0;
var warned_about_discontinued = 0;
let showBrokenPriceMessage = true;

function highlight_folders_with_errors() {
  document.querySelectorAll('.order-folder').forEach(function(folder) {
    var hasErrors = folder.querySelector('.fail, .hidden-fail, .invalid, .validation-failed, .am-error-border');
    if (hasErrors) {
      folder.classList.add('order-folder--error');
    } else {
      folder.classList.remove('order-folder--error');
    }
  });
}

function validate_order_sidebar_required(mox) {
  document
    .querySelectorAll(".required, .required-if-visible")
    .forEach(function (el) {
      if (!el.id || el.closest("form")) return;
      if (!(el.offsetWidth || el.offsetHeight || el.getClientRects().length))
        return;
      var name = el.getAttribute("name") || "";
      mox.require(
        el.id,
        name.indexOf("custom[") === 0
          ? get_language_translation("REQUIRED_FIELD_LANG")
          : undefined
      );
    });
}

function validate_order_sidebar(mox) {
  var billing_error_count = 0;
  var shipping_error_count = 0;

  validate_order_sidebar_required(mox);

  if ($("billing_name")) {
    billing_error_count += mox.validate(
      !$F("billing_name").empty(),
      "billing_name",
      get_language_translation("LANG_PLEASE_ENTER_A_BILLING_NAME") + "."
    );
    billing_error_count += mox.validate(
      !$F("billing_address1").empty(),
      "billing_address1",
      get_language_translation(
        "LANG_PLEASE_ENTER_A_VALID_BILLING_STREET_ADDRESS"
      ) + "."
    );
    billing_error_count += mox.validate(
      !$F("billing_city").empty(),
      "billing_city",
      get_language_translation("LANG_PLEASE_ENTER_A_BILLING_CITY_NAME") + "."
    );
    billing_error_count += mox.validate(
      !($F("billing_state") == null || $F("billing_state").empty()),
      "billing_state",
      get_language_translation("LANG_PLEASE_ENTER_A_VALID_BILLING_STATE") + "."
    );
    billing_error_count += mox.validate(
      !$F("billing_zip").empty(),
      "billing_zip",
      get_language_translation("LANG_PLEASE_ENTER_A_VALID_BILLING_ZIP_CODE") +
        "."
    );
  }

  if (
    $("shipping_name") &&
    $("shipping_same_as_billing") &&
    !$("shipping_same_as_billing").checked &&
    $("shipping_container") &&
    $("shipping_container").visible()
  ) {
    shipping_error_count += mox.validate(
      !$F("shipping_name").empty(),
      "shipping_name",
      get_language_translation("LANG_ERR_VALID_SHIPPING_NAME") + "."
    );
    shipping_error_count += mox.validate(
      !$F("shipping_address1").empty(),
      "shipping_address1",
      get_language_translation("LANG_ERR_VALID_SHIPPING_STREET") + "."
    );
    shipping_error_count += mox.validate(
      !$F("shipping_city").empty(),
      "shipping_city",
      get_language_translation("LANG_ERR_VALID_SHIPPING_CITY") + "."
    );
    shipping_error_count += mox.validate(
      !($F("shipping_state") == null || $F("shipping_state").empty()),
      "shipping_state",
      get_language_translation("LANG_ERR_VALID_SHIPPING_STATE") + "."
    );
    shipping_error_count += mox.validate(
      !$F("shipping_zip").empty(),
      "shipping_zip",
      get_language_translation("LANG_PLEASE_ENTER_A_SHIPPING_ZIP_CODE") + "."
    );
  }

  if (typeof validate_shipping === "function") validate_shipping(mox);

  if ($("new_contact_first"))
    mox.validate(
      !(
        $("new_contact_first").visible() &&
        ($F("new_contact_first").empty() ||
          $F("new_contact_first") ==
            $("new_contact_first").readAttribute("default_value"))
      ),
      "new_contact_first",
      get_language_translation("LANG_NEW_CONTACTS_NEED_A_FIRST_NAME")
    );
  if ($("new_contact_last"))
    mox.validate(
      !(
        $("new_contact_last").visible() &&
        ($F("new_contact_last").empty() ||
          $F("new_contact_last") ==
            $("new_contact_last").readAttribute("default_value"))
      ),
      "new_contact_last",
      get_language_translation("LANG_NEW_CONTACTS_NEED_A_LAST_NAME")
    );
  if ($("existing_contact_id"))
    mox.validate(
      !(
        $("existing_contact_id").visible() &&
        ($F("existing_contact_id") ? $F("existing_contact_id").empty() : true)
      ),
      "existing_contact_id",
      get_language_translation("LANG_CHOOSE_A_CONTACT"),
      true
    );

  if (
    billing_error_count &&
    typeof force_billing_address_entry_down === "function"
  )
    force_billing_address_entry_down();
  if (
    shipping_error_count &&
    typeof force_shipping_address_entry_down === "function"
  )
    force_shipping_address_entry_down();
}

function customer_validation(mox) {
  const originTab =
    mox &&
    mox.form &&
    mox.form.querySelector('input[name="_origin_tab"]');
  if (originTab && (originTab.value === "discover" || originTab.value === "design")) {
    validate_order_sidebar(mox);
    if (typeof get_rightside === "function") get_rightside(mox);
    return 0;
  }

  if (typeof theOrder !== "undefined" && theOrder.isTypeProject())
    validate_order_sidebar_required(mox);

  var billing_error_count = 0;
  var shipping_error_count = 0;
  var product_error_count = 0;
  $("repeat_errors").update().hide();
  $$(".success").invoke("remove");

  document
    .querySelectorAll(".order-folder #productset .item_table > tbody > tr")
    .forEach((tr) => {
      const qty = tr.querySelector(".qty");
      if (!qty) {
        return;
      }

      if (!Number(qty.value)) {
        // remove products that have no quantity
        if (
          tr.childElementCount === 3 ||
          tr.parentElement.childElementCount === 1
        ) {
          tr.closest(".product").remove();
        } else {
          tr.remove();
        }
      }
    });

  billing_error_count += mox.validate(
    !$F("billing_name").empty(),
    "billing_name",
    get_language_translation("LANG_PLEASE_ENTER_A_BILLING_NAME") + "."
  );
  billing_error_count += mox.validate(
    !$F("billing_address1").empty(),
    "billing_address1",
    get_language_translation(
      "LANG_PLEASE_ENTER_A_VALID_BILLING_STREET_ADDRESS"
    ) + "."
  );
  billing_error_count += mox.validate(
    !$F("billing_city").empty(),
    "billing_city",
    get_language_translation("LANG_PLEASE_ENTER_A_BILLING_CITY_NAME") + "."
  );
  billing_error_count += mox.validate(
    !($F("billing_state") == null || $F("billing_state").empty()),
    "billing_state",
    get_language_translation("LANG_PLEASE_ENTER_A_VALID_BILLING_STATE") + "."
  );
  billing_error_count += mox.validate(
    !$F("billing_zip").empty(),
    "billing_zip",
    get_language_translation("LANG_PLEASE_ENTER_A_VALID_BILLING_ZIP_CODE") + "."
  );
  if (
    $("shipping_same_as_billing") &&
    !$("shipping_same_as_billing").checked &&
    $("shipping_container").visible()
  ) {
    shipping_error_count += mox.validate(
      !$F("shipping_name").empty(),
      "shipping_name",
      get_language_translation("LANG_ERR_VALID_SHIPPING_NAME") + "."
    );
    shipping_error_count += mox.validate(
      !$F("shipping_address1").empty(),
      "shipping_address1",
      get_language_translation("LANG_ERR_VALID_SHIPPING_STREET") + "."
    );
    shipping_error_count += mox.validate(
      !$F("shipping_city").empty(),
      "shipping_city",
      get_language_translation("LANG_ERR_VALID_SHIPPING_CITY") + "."
    );
    shipping_error_count += mox.validate(
      !($F("shipping_state") == null || $F("shipping_state").empty()),
      "shipping_state",
      get_language_translation("LANG_ERR_VALID_SHIPPING_STATE") + "."
    );
    shipping_error_count += mox.validate(
      !$F("shipping_zip").empty(),
      "shipping_zip",
      get_language_translation("LANG_PLEASE_ENTER_A_SHIPPING_ZIP_CODE") + "."
    );
  }
  if ($("cart_product"))
    mox.validate(
      $("cart_product").childElements().length == 0,
      "cart_product",
      get_language_translation(
        "LANG_THERE_IS_AN_UNFINISHED_PRODUCT_WHICH_HASENT_YET_BEEN_ADDDED_TO_THE_CART_PLZ_ADD_OR_DISCARD"
      )
    );
  var blanks = check_for_blank_attributes();
  if (blanks) {
    product_error_count += blanks;
    mox.failed = true;
  }

  const orderStatus = document.querySelector("#status")?.value;
  const ALLOW_SAVE_BIDS_WITH_ERRORS =
    allowToSaveBidWithValidationErrorsEnabled();
  let productWithValidationErrorCount =
    document.querySelectorAll(".fail").length;

  if (orderStatus === "bid" && ALLOW_SAVE_BIDS_WITH_ERRORS) {
    productWithValidationErrorCount = 0;
  }
  if (ALLOW_SAVE_BIDS_WITH_ERRORS && theOrder.orderStatusIsDirty() === true && theOrder.getOrderStatus() === ORDER_STATUS_BID) {
    productWithValidationErrorCount = 0;
  }

  const isProject = theOrder.isTypeProject();
  if (!isProject) {
    product_error_count += mox.validate(
        get_quantity("productset") +
        get_quantity("supplyset") +
        get_quantity("componentset") >
        0,
        "supplyset",
        get_language_translation("LANG_ERR_NO_EMPTY_ORDERS")
    );
  } else {
    const projectInvalidLineItemsCount = validateProjectOrderLineItems();
    if (projectInvalidLineItemsCount > 0) {
      mox.failed = true;
    }
    mox.validate(
        projectInvalidLineItemsCount === 0,
        "notifications",
        "1 " +
        get_language_translation("LANG_OR_MORE_OF_YOUR_ITEMS_HAS_ERRORS") +
        ".",
    );
  }
  product_error_count += mox.validate(
    productWithValidationErrorCount === 0,
    "notifications",
    "1 " +
      get_language_translation("LANG_OR_MORE_OF_YOUR_ITEMS_HAS_ERRORS") +
      "."
  );
  product_error_count += mox.validate(
    $$(".invalid").length == 0,
    "notifications",
    "1 " +
      get_language_translation("LANG_OR_MORE_OF_YOUR_ITEMS_HAS_ERRORS") +
      ".",
    true
  );
  mox.validate(
    $("_shipping_error") == undefined,
    "notifications",
    get_language_translation(
      "LANG_PLZ_FIX_THE_SHIPPING_ERRORS_BEFORE_SUBMITTING"
    ) + ".",
    true
  );
  validate_shipping(mox);
  mox.require("name", get_language_translation("LANG_ERR_REQUIRES_NAME"));
  if ($("new_contact_first"))
    mox.validate(
      !(
        $("new_contact_first").visible() &&
        ($F("new_contact_first").empty() ||
          $F("new_contact_first") ==
            $("new_contact_first").readAttribute("default_value"))
      ),
      "new_contact_first",
      get_language_translation("LANG_NEW_CONTACTS_NEED_A_FIRST_NAME")
    );
  if ($("new_contact_last"))
    mox.validate(
      !(
        $("new_contact_last").visible() &&
        ($F("new_contact_last").empty() ||
          $F("new_contact_last") ==
            $("new_contact_last").readAttribute("default_value"))
      ),
      "new_contact_last",
      get_language_translation("LANG_NEW_CONTACTS_NEED_A_LAST_NAME")
    );
  if ($("existing_contact_id"))
    // Funky logic here because of when an invalid primary contact is configured (e.g. admin) and selected value gets set to null, on which .empty() chokes
    mox.validate(
      !(
        $("existing_contact_id").visible() &&
        ($F("existing_contact_id") ? $F("existing_contact_id").empty() : true)
      ),
      "existing_contact_id",
      get_language_translation("LANG_CHOOSE_A_CONTACT"),
      true
    );

  if (product_error_count) force_order_cart_down();
  if (billing_error_count) force_billing_address_entry_down();
  if (shipping_error_count) force_shipping_address_entry_down();

  highlight_folders_with_errors();

  if (showBrokenPriceMessage) {
    const invalidProducts = validateProductPricing();
    const order_contains_invalid_prices = invalidProducts.length > 0;

    toggle_order_status_controls(order_contains_invalid_prices);

    if (order_contains_invalid_prices) {
      show_products_with_error_modal(invalidProducts);
      mox.failed = true;
      return;
    }
  }

  if (mox.failed) {
    show_order_error_modal();
  } else if (!warned_cust && $("productset").select(".notice").length > 0) {
    show_order_warning_modal();
    mox.failed = true;
    warned_cust = 1;
    warned_about_discontinued = 1; // We're gonna take a wild leap and assume people examine ALL warnings
  } else if (
    (warned_about_discontinued == -1 &&
      $$('p.notice[data-item_unavailable="1"][data-remote_notice="1"]').length >
        0) ||
    (warned_about_discontinued == 0 &&
      $$('p.notice[data-item_unavailable="1"]').length > 0)
  ) {
    show_discontinued_items_warning_model();
    mox.failed = true;
    warned_about_discontinued = 1;
  } else {
    if (Modalbox.initialized)
      Modalbox._hide({
        stop: function () {},
        element: function () {
          return { id: "MB_overlay" };
        },
      }); // close Modalbox
    get_rightside(mox);
    disable_order_submission_buttons();
  }
}

/**
 * This disables the submit order button when the user is logged in as a customer
 * */
function toggleSubmitOrderButton(enabled = false) {
  const { is_admin } = get_user_info();

  if (is_admin) {
    /**
     * When the user is administrator we don't want to disable the submit order button
     * because it's the same as the save order button, and that will cause the page to be useless.
     * */
    return;
  }

  /** @type HTMLAnchorElement {submitButton} */
  const submitButton = document.querySelector("#order_submit2");

  if (!submitButton) {
    return;
  }

  submitButton?.classList.toggle("disabled", !enabled);

  if (enabled) {
    if (submitButton?.dataset.href) {
      submitButton.href = submitButton?.dataset.href;
    }
    // restore the on click callback
    if (typeof window["ordersSubmitButton_onClick"] === "function") {
      submitButton.onclick = window["ordersSubmitButton_onClick"];
    }

    // remove the tooltip text tou avoid confusion after the button is enabled.
    submitButton.title = null;

    // destroy the tooltip
    const tooltip = bootstrap.Tooltip.getInstance(submitButton);
    tooltip?.dispose();
  } else {
    submitButton.dataset.href = submitButton?.href;
    if (typeof submitButton?.onclick === "function") {
      window["ordersSubmitButton_onClick"] = submitButton?.onclick;
    }

    submitButton.href = "javascript:void(0)";
    submitButton.onclick = null;

    // add tooltip
    submitButton.title = get_language_translation(
      "LANG_SAVE_AS_BID_VALIDATION_MESSAGE"
    );
    submitButton.dataset.bsToggle = "tooltip";
    submitButton.dataset.bsPlacement = "auto";
    initializeTooltips();
  }
}

/**
 * Disables all the options but bid and void
 * if the enabled parameter is true, restores the options
 * */
function toggleOrderStatusDropdown(enabled = false) {
  const allowedStatuses = ["bid", "void"];

  /** @type HTMLSelectElement */
  const statusDropdown = document.querySelector("select#status");

  if (!statusDropdown) {
    return;
  }

  for (/** @type HTMLOptionElement */ const op of statusDropdown.options) {
    if (enabled) {
      op.disabled = false;
    } else {
      op.disabled = !allowedStatuses.includes(op.value);
    }
  }
}

function toggle_order_status_controls(invalid) {
  const $order_status_dropdown = am.$("#status");
  const $invalid_prices_alert = am.$("#products_with_broken_price_alert");

  $invalid_prices_alert.toggle(invalid);
  $order_status_dropdown.attr("disabled", invalid);
}

function show_order_error_modal() {
  var myHTML =
    '<div class="center">' +
    '<i class="fa fa-exclamation-triangle fa-5" aria-hidden="true" style="color: var(--md-sys-color-error)"></i>' +
    "<p><strong>" +
    get_language_translation("LANG_YOU_HAVE_ERRORS_ON_THIS_ORDER") +
    "</strong><br />" +
    get_language_translation("LANG_PLEASE_CORRECT_THEM_BEFORE_SUBMITTING") +
    ".</p>" +
    '<a class="am-btn am-btn--tonal" onclick="Modalbox.hide(); return false;"><span><i class="fal fa-times"></i>' +
    get_language_translation("LANG_BTN_RETURN") +
    "</span></a></div>" +
    "</div>";

  Modalbox.show(myHTML, {
    title: get_language_translation("LANG_ERR_ERRORS_ON_ORDER"),
    width: 350,
  });
  return false;
}

/**
 * @return {Array.<Object>}
 * */
function validateProductPricing() {
  const subtotals = document.querySelectorAll(".p_subtotal");
  const invalidProducts = [];

  subtotals.forEach(
    /** @param {HTMLDivElement} subtotalItem */ function (subtotalItem) {
      const data = subtotalItem.dataset;
      const quantityInput = document.querySelector(
        '[name="' + data.productNamebase + '[_qty]"]'
      );
      const currentDiscountField = document.querySelector("#disc_percent");

      if (!quantityInput) {
        console.warn(
          get_language_translation("LANG_NO_QTY_INPUT_FOUND_FOR") + ": ",
          subtotalItem
        );
        return;
      }

      const currentDiscount = currentDiscountField
        ? currentDiscountField.value
        : 0;
      const isPriceValid =
        subtotalItem.dataset.validPrice === "true" ||
        subtotalItem.dataset.validPrice === true;
      const quantity = parseFloat(quantityInput.value) ?? 0;

      if (!isPriceValid || quantity === 0) {
        if (invalidProducts.some((x) => x.id === data.productId)) return;
        invalidProducts.push({
          id: data.productId,
          name: data.productName,
          qty: quantity,
          companyName: data.companyName,
        });
      }
    }
  );

  return invalidProducts;
}


/**
 * @param {Array.<Object>} products
 * */
function show_products_with_error_modal(products) {
  const companyName = products[0].companyName;
  const userType = document.getElementById("user-type").value ?? "customer";

  let htmlMessage =
    '<div class="center">' +
    '<i class="fa fa-exclamation-triangle fa-5" aria-hidden="true" style="color: var(--md-sys-color-error)"></i>' +
    "<p><strong>" +
    get_language_translation("LANG_YOU_HAVE_ERRORS_ON_THIS_ORDER") +
    "</strong>";

  if (userType === "customer") {
    htmlMessage +=
      "<br />" +
      get_language_translation(
        "LANG_THE_FOLLOWING_PRODUCTS_HAVE_AN_ERROR_IN_PRICE"
      ) +
      ".</p>";
  } else {
    htmlMessage +=
      "<br />" +
      get_language_translation(
        "LANG_THE_FOLLOWING_PRODUCTS_HAVE_AN_ERROR_IN_THEIR_PRICE_FORMULA"
      ) +
      ".</p>";
  }

  htmlMessage += '<ul style="text-align: left">';
  products.forEach(function (product) {
    htmlMessage += "<li>" + product.name + "</li>";
  });
  htmlMessage += "</ul>";

  if (userType === "customer") {
    htmlMessage +=
      "<br /><p>" +
      get_language_translation(
        "LANG_THIS_ORDER_WILL_ONLY_BE_SAVED_AS_A_BID_UNTIL_THESE_ERRORS_ARE_SOLVED"
      ) +
      ". " +
      "<br>" +
      get_language_translation("LANG_PLZ_REACH_OUT_TO") +
      " <b>" +
      companyName +
      "</b> " +
      get_language_translation("LANG_MSG_ORDER_INFO_TPL_MSG3_PT2") +
      "</p>";
  } else {
    htmlMessage +=
      "<br /><p>" +
      get_language_translation(
        "LANG_SAVING_THIS_ORDER_WITH_THE_CHANGES_YOUVE_MADE_WILL_RESULT_IN"
      ) +
      " " +
      get_language_translation(
        "LANG_THOSE_PRODUCTS_HAVING_NO_PRICE_UNTIL_THEIR_PRICE_FORMULAS_HAVE_BEEN_FIXED"
      ) +
      ".</p>";
  }

  htmlMessage +=
    '<a class="am-btn am-btn--tonal" onclick="Modalbox.hide(); showBrokenPriceMessage = false; return false;">' +
    '<span><i class="fal fa-times"></i>' +
    get_language_translation("LANG_ACCEPT_AND_CLOSE") +
    "</span></a></div>" +
    "</div>";

  Modalbox.show(htmlMessage, {
    title: get_language_translation("LANG_PRODUCT_ERROR"),
    width: 350,
  });
}

function show_order_warning_modal() {
  var myHTML =
    '<div class="center">' +
    '<i class="fa fa-exclamation-triangle fa-5" aria-hidden="true" style="color: #ffc639"></i>' +
    "<p>" +
    get_language_translation(
      "LANG_THIS_PAGE_IS_DISPLAYING_IMPORTANT_INFORMATION_THAT_REQUIRES_YOUR_ACKNOWLEDGEMENT_PLZ_REVIEW_THE_WHOLE_PAGE"
    ) +
    "</p>" +
    '<a class="am-btn am-btn--tonal" onclick="Modalbox.hide(); return false;"><span>' +
    get_language_translation("LANG_REVIEW") +
    "</span></a></div>" +
    "</div>";

  Modalbox.show(myHTML, {
    title: get_language_translation("LANG_WARNINGS_ON_ORDER"),
    width: 350,
  });
  return false;
}
function show_discontinued_items_warning_model() {
  Modalbox.show(
    '<div class="center">' +
      '<i class="fa fa-exclamation-triangle fa-5" aria-hidden="true" style="color: #FFC639"></i>' +
      "<p>" +
      get_language_translation(
        "LANG_THIS_ORDER_CONTAINS_DISCONTINUED_ITEMS_WHICH_MAY_BE_REMOVED_FROM_THIS_ORDER_UPON_SUBMISSION"
      ) +
      "</p>" +
      '<a class="am-btn am-btn--tonal" onclick="Modalbox.hide(); return false;"><span>' +
      get_language_translation("LANG_REVIEW") +
      "</span></a></div>" +
      "</div>",
    {
      title: get_language_translation("LANG_WARNINGS_ON_DISCONTINUED_ITEMS"),
      width: 350,
    }
  );
}

function validate_shipping(mox) {
  var ele = "shipping_zip";
  var error_count = 0;
  if (
    !$("shipping_container").visible() ||
    $("shipping_same_as_billing").checked
  ) {
    // Clear shipping errors
    [
      "shipping_container",
      "shipping_name",
      "shipping_address1",
      "shipping_city",
      "shipping_state",
      "shipping_zip",
    ].forEach(function (item) {
      mox.validate(true, item);
    });
  }
  $$(".shipping_method_set").each(function (set) {
    var el_shipping_method = set.down(".shipping_method");
    // Clear shipping errors
    mox.validate(true, el_shipping_method.getAttribute("id"));
    if (
      mox.validate(
        el_shipping_method.value.length,
        el_shipping_method.getAttribute("id"),
        get_language_translation("LANG_PLEASE_SEL_A_SHIPPING_METHOD") + "."
      )
    )
      // No shipping method selected
      error_count++;

    if (
      $("shipping_container").visible() &&
      !$("shipping_same_as_billing").checked
    ) {
      error_count += mox.validate(
        !$F("shipping_name").empty(),
        "shipping_name",
        get_language_translation("LANG_ERR_VALID_SHIPPING_NAME")
      );
      error_count += mox.validate(
        !$F("shipping_address1").empty(),
        "shipping_address1",
        get_language_translation("LANG_ERR_VALID_SHIPPING_STREET")
      );
      error_count += mox.validate(
        !$F("shipping_city").empty(),
        "shipping_city",
        get_language_translation("LANG_ERR_VALID_SHIPPING_STREET")
      );
      error_count += mox.validate(
        !$F("shipping_state").empty(),
        "shipping_state",
        get_language_translation("LANG_ERR_VALID_SHIPPING_STATE")
      );

      if (
        $("shipping_country").value == "United States" ||
        $("shipping_country").value == "Canada"
      ) {
        error_count += mox.validate(
          $F(ele).match(/^\d{5}(\-\d{4})?$/) ||
            $F(ele).match(/^[A-Za-z]\d[A-Za-z]( )?\d[A-Za-z]\d$/),
          $(ele) ? ele : "shipping_container",
          get_language_translation(
            "LANG_PLEASE_ENTER_A_VALID_5_OR_9_DIGIT_US_ZIP_OR_6_CHAR_CAD_ZIP_CODE_IN_SHIPPING_ADDRESS"
          ) + "."
        );
      } else {
        error_count += mox.validate(
          !$(ele).value.blank(),
          $(ele) ? ele : "shipping_container",
          get_language_translation("LANG_ZIP_CANT_BE_EMPTY_IN_SHIPPING") + "."
        );
      }
    }
    if (error_count) force_shipping_address_entry_down();
  });
}
function customer_cancel_order_validation(mox) {
  customer_validation(mox);
  if (mox.failed) {
    if ($("_u_o_")) $("_u_o_").remove();
  } else
    mox.form.insert(
      new Element("input", {
        id: "_u_o_",
        type: "hidden",
        name: "unplace_order",
        value: "1",
      })
    );
}
function customer_invoice_validation(mox) {
  $("productset")
    .select(".p_subtotal")
    .each(function (subtotal) {
      mox.validate(
        subtotal.innerHTML != "$-",
        subtotal.up("table"),
        get_language_translation(
          "LANG_THERE_IS_A_PRICING_ERROR_ON_THIS_PRODUCT_THE_ORDER_CANNOT_YET_BE_COMPLETED"
        )
      );
    });
  customer_validation(mox);
  if (mox.failed) {
    if ($("_p_o_")) $("_p_o_").remove();
  } else {
    mox.form.insert(
      new Element("input", {
        id: "_p_o_",
        type: "hidden",
        name: "place_order",
        value: "1",
      })
    );
    disable_order_submission_buttons();
  }
}
// DEV-13785: B2B tiles render blank (get_cats makes no supplier calls, DEV-13127) and carry
// data-b2b-image="Type:installation_id:num". Fill them with one request (the server batches one
// call per supplier); results are cached because the selector HTML is reused across folders.
const b2bTileImageCache = new Map();
function loadB2BTileImages(root) {
  const scope = root || document;
  const tiles = Array.from(
    scope.querySelectorAll("img[data-b2b-image]:not(.b2b-image-requested)")
  );
  if (!tiles.length) return;
  tiles.forEach((img) => img.classList.add("b2b-image-requested"));

  const apply = () => {
    let filled = false;
    tiles.forEach((img) => {
      const src = b2bTileImageCache.get(img.dataset.b2bImage);
      if (src) {
        img.setAttribute("data-src", src);
        img.classList.add("lazyImage");
        filled = true;
      }
    });
    if (filled) lazyImageLoad();
  };

  const missing = [
    ...new Set(tiles.map((img) => img.dataset.b2bImage)),
  ].filter((key) => !b2bTileImageCache.has(key));
  if (!missing.length) {
    apply();
    return;
  }

  const formData = new FormData();
  missing.forEach((key) => formData.append("items[]", key));
  fetch("ajax/orders/get_b2b_tile_images/", { method: "POST", body: formData })
    .then((response) => (response.ok ? response.json() : {}))
    .then((images) => {
      // Remember misses too (empty string) so blank tiles don't re-ask.
      missing.forEach((key) => b2bTileImageCache.set(key, images[key] || ""));
      apply();
    })
    .catch((error) => console.warn("B2B tile images unavailable:", error));
}

function catsel(id, where, folder_id) {
  where = where || "orders";
  var params = {};
  if (id) params["id"] = id;
  if ($("company_id")) params["company_id"] = $F("company_id");
  if ($("itemized_order"))
    // !! Temporary disabling of B2B items in itemized orders !!
    params["itemized_order"] = $F("itemized_order");

  if ($("jobs") && $("jobs").getAttribute("data-order_id")) {
    var order_id = $("jobs").getAttribute("data-order_id");
    if (order_id) params["order_id"] = order_id;
  }

  new Ajax.Request("ajax/" + where + "/get_cats/", {
    parameters: params,
    onSuccess: function (ret) {
      const folder_selector = folder_id ? "#" + folder_id : "";
      am.$(folder_selector + " #new_product").html(ret.responseText);

      const addFolderTemplate = GUI.templates["add-folder"] ?? null;
      if (
        null != addFolderTemplate &&
        window.add_folder_template_updated === false
      ) {
        const templateElement = document.createElement("div");
        templateElement.innerHTML = addFolderTemplate;
        const categorySelectorElement =
          templateElement.querySelector("#new_product");
        if (categorySelectorElement) {
          categorySelectorElement.innerHTML = ret.responseText;
          GUI.templates["add-folder"] = templateElement.innerHTML;
          window.add_folder_template_updated = true;
        }
      }

      product_quick_search_init(folder_id);

      const $inputs = am.$(folder_selector + " #product_quick_search");
      if ($inputs.length > 0) {
        $inputs.each(function (index, element) {
          MoxForm(element);
        });
      } else {
        MoxForm("product_quick_search");
      }
      theOrder.show_loading_button(false);
      lazyImageLoad();
      loadB2BTileImages(
        document.querySelector(folder_selector + " #new_product")
      );
    },
  });
  return false;
}

async function loadFolderCategorySelector() {
  /** @type NodeListOf<HTMLDivElement> */
  const $folders = document.querySelectorAll(".order-folder");
  // don't load if there are no folders on the page
  if (0 === $folders.length) {
    return;
  }
  let categorySelectorHtml = window["categorySelectorHtml"] ?? null;
  if (!categorySelectorHtml) {
    try {
      const formData = new FormData();
      const companyId = document.querySelector("#company_id")?.value ?? null;
      if (companyId) {
        formData.append("company_id", companyId);
      }
      const response = await fetch("ajax/orders/get_cats/", {
        method: "POST",
        body: formData,
      });
      categorySelectorHtml = await response.text();
      window["categorySelectorHtml"] = categorySelectorHtml;
    } catch (error) {
      console.error("Failed to get the category selector HTML:", error);
    }
  }

  if (!categorySelectorHtml) {
    console.info(
      "Cannot assign category selector to folders because the HTML could not be fetched."
    );
    return;
  }

  for (const $folder of $folders) {
    /** @type HTMLDivElement */
    const categorySelectorContainer = $folder.querySelector(".new_product");
    const folderIdSelector = $folder.id;

    if (
      categorySelectorContainer &&
      categorySelectorContainer.dataset.loadedCategories !== "true"
    ) {
      categorySelectorContainer.innerHTML = categorySelectorHtml;
      categorySelectorContainer.firstElementChild.id =
        "category_selector_" + folderIdSelector;

      product_quick_search_init(folderIdSelector);
      const $searchElement = document.querySelector(
        "#" + folderIdSelector + " #product_quick_search"
      );
      if ($searchElement) {
        MoxForm($searchElement);
      }
      lazyImageLoad();
      loadB2BTileImages(categorySelectorContainer);

      categorySelectorContainer.dataset.loadedCategories = "true";
    }
  }
}

function frac_to_dec(fieldvalue) {
  if (!isNaN(fieldvalue)) return fieldvalue;
  var dec = 0;
  var temp = fieldvalue.split("/");
  if (temp.length == 1) return fieldvalue;
  var den = temp[1];
  var temp2 = temp[0].split(" ");
  if (temp2.length > 1) {
    var whole = temp2[0];
    var num = temp2[1];
  } else {
    var whole = 0;
    var num = temp2[0];
  }
  if (den > 0) dec = num / den;
  return Number(whole) + Number(dec);
}
function edit_price(el, set_id, opi_id, roverride) {
  // !!!! TEMPORARY FUNCTION FOR BACKWARDS-COMPATIBILITY !!!!
  return edit_product_price(el, set_id, opi_id, roverride);
}

function remove_input_value(el) {
  if (el.up("form#c_form")) {
    el.up("tr")
      .select(".error_container")[0]
      .insert(
        '<div class="notice">' +
          get_language_translation(
            "LANG_YOU_CANNOT_OVERRIDE_PRICES_IN_THE_COMPONENT_EDITOR"
          ) +
          ".</div>"
      )
      .show();
    return false;
  }

  let type = el.getAttribute("data-type");
  const onclick = el.getAttribute("data-onclick");
  const input = el.siblings("input")[0];
  const data_input_type = input.getAttribute("data-input-type");
  const data_precision = input.getAttribute("data-precision");
  const $price = $(el).up(".price");
  let $container = null;

  if ($($price).up(".component")) {
    $container = $($price).up(".component");
    type = "component";
  } else if (type === "product" || type === "supply") {
    $container = $($price).up(".product");
  }

  $price.replace(
    '<div class="pao_bottom price"><a href="javascript:void(0);" onclick="' +
      onclick +
      '" class="priceoverride" data-input-type="' +
      data_input_type +
      '" data-precision="' +
      data_precision +
      '">' +
      get_currency_symbol() +
      "-" +
      "</a></div>"
  );

  order_item_changed(type, $container);

  return false;
}
function edit_product_price(el, set_id, opi_id, roverride, instance) {
  if (el.up("form#c_form")) {
    el.up("tr")
      .select(".error_container")[0]
      .insert(
        '<div class="notice">' +
          get_language_translation(
            "LANG_YOU_CANNOT_OVERRIDE_PRICES_IN_THE_COMPONENT_EDITOR"
          ) +
          ".</div>"
      )
      .show();
    return false;
  }
  var cur_price = cur2num(el.innerHTML.substr(1).split("<br>")[0]);
  if (opi_id)
    var name =
      "[" +
      set_id +
      "][items][" +
      opi_id +
      "][" +
      (roverride ? "roverride" : "price_override") +
      "]";
  else
    var name =
      "[" + set_id + "][" + (roverride ? "roverride" : "price_override") + "]";
  if (el.up(".component"))
    name =
      "pcomponents[" +
      el.up(".component").getAttribute("data-component_set_id") +
      "][products]" +
      name;
  else name = "products" + name;

  // TODO: stop finding overrides via getElementById
  var id =
    "price_override_" + set_id + (opi_id ? "_" + opi_id : "") + "_" + instance;
  const onclick = el.getAttribute("onclick");
  const data_input_type = el.getAttribute("data-input-type");
  const data_precision = el.getAttribute("data-precision");

  el.replace(
    "<div class='price_override_editor'>" +
      get_currency_symbol() +
      "<input type='text' id='" +
      id +
      "' class='price_override' onchange='order_item_changed(\"product\", $(this).up(\".product\"));' name='" +
      name +
      "' size='4' value='" +
      cur_price +
      "' data-input-type='" +
      data_input_type +
      "' data-precision='" +
      data_precision +
      "'/>" +
      "<i class='fas fa-times-circle' data-onclick=\"" +
      onclick +
      "\" data-type='product' onclick='remove_input_value(this)'></i></div>"
  );

  $(id).focus();
  $(id).select();
  return false;
}
function edit_supply_price(el, set_id, roverride) {
  if (el.up("form#c_form")) {
    el.up("tr")
      .select(".error_container")[0]
      .insert(
        '<div class="notice">' +
          get_language_translation(
            "LANG_YOU_CANNOT_OVERRIDE_PRICES_IN_THE_COMPONENT_EDITOR"
          ) +
          ".</div>"
      )
      .show();
    return false;
  }
  const onclick = el.getAttribute("onclick");
  const data_input_type = el.getAttribute("data-input-type");
  const data_precision = el.getAttribute("data-precision");
  var cur_price = cur2num(el.innerHTML.substr(1).split("<br>")[0]);
  var name =
    "[" + set_id + "][" + (roverride ? "roverride" : "price_override") + "]";
  if (el.up(".c_supplyset"))
    name =
      "pcomponents[" +
      el.up(".component").getAttribute("data-component_set_id") +
      "][supplies]" +
      name;
  else name = "psupplies" + name;

  // TODO: stop finding overrides via getElementById
  var id = "price_override_" + set_id;
  var a = document.getElementsByClassName("toggle_price_overide")[0];
  el.replace(
    "<div class='price_override_editor'>" +
      get_currency_symbol() +
      "<input type='text' id='" +
      id +
      "' class='price_override' onchange='order_item_changed(\"supply\", $(this).up(\".product\"));' name='" +
      name +
      "' size='4' value='" +
      cur_price +
      "' data-input-type='" +
      data_input_type +
      "' data-precision='" +
      data_precision +
      "' />" +
      "<i class='fas fa-times-circle' onclick='remove_input_value(this)' data-onclick=\"" +
      onclick +
      "\" data-type='supply'></i>" +
      "</div>"
  );
  $(id).focus();
  $(id).select();
  return false;
}
function edit_gt_tax_rate(el) {
  return toggle_override(el, "gt_tax_rate_override", "tax,tax_rate", 3);
}
function edit_gt_gst_rate(el) {
  return toggle_override(el, "gt_gst_rate_override", "tax,tax_rate", 3);
}
function edit_gt_pst_rate(el) {
  return toggle_override(el, "gt_pst_rate_override", "tax,tax_rate", 3);
}
function edit_shipping(el) {
  return toggle_override(
    el,
    "shipping_override",
    "shipping",
    2,
    get_currency_symbol(),
    ""
  );
}
var saved_overrides = [];
function toggle_override(
  el,
  name,
  invalidate,
  round_num,
  before_char,
  after_char
) {
  before_char = before_char || "";
  after_char = after_char || "";
  var cur_value = number_format(cur2num(el.innerHTML), 2);

  let onBlur = "this.value=number_format(Math.abs(cur2num(this.value))," + round_num + ");";

  if (String(invalidate).include(",")) {
    const invalidates = invalidate.split(",").map(function (i) {
      return "invalidate('" + i + "')";
    }).join(".");
    onBlur += " theOrder." + invalidates + ".process();";
  } else {
    onBlur += " theOrder.invalidate('" + invalidate + "').process();";
  }

  var input = new Element("input", {
    name: name,
    id: name,
    size: "6",
    value: cur_value,
    onblur: onBlur,
  }).addClassName("am-totals__field text currency"); // the part class: same anatomy as the template-rendered overrides (150px, seated reset)
  var box = new Element("span", { id: name + "_container" })
    .addClassName("override_container")
    .insert(before_char)
    .insert(input)
    .insert(after_char);
  var cancel_link = new Element("i", {
    "data-or-id": el.id,
    "data-ov-id": name,
    "data-before-char": before_char,
    "data-after-char": after_char,
    "data-invalidate": invalidate,
  }).addClassName("ptr fa fa-trash delete_link");
  cancel_link.observe("click", return_to_auto);
  var amt = el.innerHTML;
  saved_overrides[name] = el.replace(box.outerHTML);
  saved_overrides[name].innerHTML = amt;
  $(name + "_container").insert(cancel_link);
  //	el.replace(before_char + '<input type="text" id="' + name + '" name="' + name + '" class="text currency" onblur="this.value=number_format(cur2num(this.value),2); order.pricing();" size="6" value="' + number_format(cur_price, 2) + '" /> ' + after_char + '<a id="back_to_auto" class="delete_link" href="javascript:void(0);" onclick="return auto_shipping(this);"><i class="fa fa-trash"></i></a>');
  $(name).focus();
  $(name).select();
  return false;
}
function return_to_auto(ev) {
  if (typeof ev.element == "function") {
    ev.preventDefault();
    var el = ev.element();
  } else var el = ev;
  var id = el.getAttribute("data-ov-id");
  var before_char = el.readAttribute("data-before-char");
  var after_char = el.readAttribute("data-after-char");
  /**@type {string} invalidate*/
  var invalidate = el.readAttribute("data-invalidate");
  if (saved_overrides[id]) {
    var new_val = $F(id);
    el.up(".override_container").replace(saved_overrides[id]);
  } else {
    var old_value = el.readAttribute("data-text");
    var old_id = el.readAttribute("data-or-id");
    var hint = el.readAttribute("data-auto-hint");
    var new_el = new Element("span", {
      id: old_id,
      onclick: "return edit_" + old_id + "(this)",
    }).update(before_char + old_value + after_char);
    if (hint.length) {
      new_el.addClassName("hint--right hint--no-animate hint--rounded");
      new_el.writeAttribute("data-hint", hint);
    }
    el.up(".override_container").replace(new_el);
  }
  if (invalidate && invalidate.includes("tax_rate")) {
    var form = el.closest("form");
    if (form) {
      var refreshInput = form.querySelector("input[name='tax_rate_refresh_requested']");
      if (refreshInput) {
        refreshInput.value = "1";
      } else {
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = "tax_rate_refresh_requested";
        input.value = "1";
        form.appendChild(input);
      }
    }
  }
  if (invalidate === "shipping") {
    // the line below is not working so we call tax
    theOrder.invalidate("tax").process();
  }
  if (invalidate.include(",")) {
    const sections = invalidate.split(",");

    sections.forEach((section) => {
      theOrder.invalidate(section.trim());
    });
    theOrder.process();
  } else {
    theOrder.invalidate(invalidate).process();
  }
}

function change_order_status(id, status) {
  new Ajax.Request("ajax/orders/change_order_status/", {
    parameters: { order_id: id, status: status },
    onSuccess: function (ret) {
      $("s" + id).update("Shipped");
    },
  });
}
var selCompany = null;
function select_company(cause, effect, force_price_recalculation = true) {
  var id = $F(cause);
  var company_name = null;

  if (id != 0) {
    if ($(cause).tagName === "SELECT") {
      company_name = $(cause).select("option[value=" + id + "]")[0].text;
      $("shipping_name").value = company_name;
      $("billing_name").value = company_name;
    } else {
      company_name = $F("company_name");
    }
  } else {
    $("shipping_name").value = "";
    $("billing_name").value = "";
    var ele = $("gt_tax_rate");
    if (ele.value) {
      ele.value = "0.000";
    } else {
      ele.update("0.000");
    }
  }

  if (id) {
    if (selCompany && callInProgress(selCompany.transport))
      selCompany.transport.abort();
    var instances = [];
    $$(".shipping_method_set").each(function (set) {
      instances.push(set.getAttribute("data-instance"));
    });
    selCompany = new Ajax.Request("ajax/", {
      parameters: {
        table: "select_contacts",
        company_id: id,
        instances: JSON.stringify(instances),
      },
      onSuccess: function (ret) {
        populate_from_results(ret.responseJSON, effect);
        if ($("limit_notice")) {
          if (ret.responseJSON.remaining_limit)
            $("limit_notice").setAttribute(
              "data-remaining-limit",
              ret.responseJSON.remaining_limit
            );
          else $("limit_notice").setAttribute("data-remaining-limit", "");
        }
        if ($("account_jump_contact")) existing_contact_id_changed();
        if (force_price_recalculation) {
          $$(".valid")
            .invoke("removeClassName", "valid")
            .invoke("addClassName", "stale"); // Force price recalculation
          theOrder
            .invalidate("items")
            .invalidate("shipping")
            .invalidate("tax_rate")
            .process();
        }
      },
    });
    window.add_folder_template_updated =
      window.add_folder_template_updated || false;
    catsel();
    if ($(cause).tagName === "SELECT") {
      cause.setAttribute("title", cause[cause.selectedIndex].text);
    } else {
      cause.setAttribute("title", company_name);
    }
  } else {
    if (effect) {
      effect.update(
        "<option>--" +
          get_language_translation("LANG_OPT_SEL_A_COMP_FIRST") +
          "--</option>"
      );
      effect.disable();
      cause.setAttribute("title", "");
    }
  }
}

function populate_from_results(response, select) {
  if (typeof response == "object" && "tags" in response && Array.isArray(response.tags)) {
    theOrder.setCompanyTags(response.tags);
    toggleSelectOptionsVisibilityByCompanyTags();
  }
  if (
    !response ||
    !(typeof response == "object") ||
    !response.contacts ||
    response.contacts.length == 0
  ) {
    if (select) {
      select.update(
        '<option value="">' +
          get_language_translation("LANG_NO_CONTACTS_EXIST") +
          "</option>"
      );
      select.disable();
    }
  } else {
    if (select) {
      select.update(
        '<option value="">--' +
          get_language_translation("LANG_OPT_SELECT_ONE") +
          "--</option>"
      );
      for (var i = 0; i < response.contacts.length; i++) {
        select.insert(
          '<option value="' +
            response.contacts[i][0] +
            '">' +
            response.contacts[i][1] +
            "</option>"
        );
      }
      select.enable();
      // We deactivate this because we don't know what the reason of it 🙃
      /*const contactval = select.getAttribute('data-ordercontact');
			if (contactval && !isNaN(contactval)) {
				select.value = contactval;
			}
			else*/ if (response.primary_contact_id)
        select.value = response.primary_contact_id;
      else select.childElements()[0].selected = true;
    }
  }
  // clear_addresses('billing');
  // clear_addresses('shipping');
  if (response && typeof response == "object" && response.addresses) {
    $("existing_billing").update(
      '<option value="">--' +
        get_language_translation("LANG_USE_AN_EXISTING_ADDRESS") +
        "--</option>"
    );
    $("existing_shipping").update(
      '<option value="">--' +
        get_language_translation("LANG_USE_AN_EXISTING_ADDRESS") +
        "--</option>"
    );
    var billing_default = 0,
      shipping_default = 0;
    for (i = 0; i < response.addresses.length; i++) {
      if (response.addresses[i].json.isJSON()) {
        var json = response.addresses[i].json.evalJSON();
        const billing_addr_id =
          $("existing_billing").getAttribute("data-value");

        if (!billing_addr_id) {
          if (json["default"] == 1 && json.address_type == "billing") {
            billing_default = i + 1;
          }
        } else {
          if (json.address_id == billing_addr_id) {
            billing_default = i + 1;
          }
        }

        const shipping_addr_id =
          $("existing_shipping").getAttribute("data-value");
        if (!shipping_addr_id) {
          if (json["default"] == 1 && json.address_type == "shipping") {
            shipping_default = i + 1;
          }
        } else {
          if (json.address_id == shipping_addr_id) {
            shipping_default = i + 1;
          }
        }
      }
      $("existing_billing").insert(
        "<option value='" +
          response.addresses[i].json +
          "'>" +
          response.addresses[i].display +
          "</option>"
      );
      $("existing_shipping").insert(
        "<option value='" +
          response.addresses[i].json +
          "'>" +
          response.addresses[i].display +
          "</option>"
      );
    }
    $("existing_billing").selectedIndex = billing_default;
    $("existing_shipping").selectedIndex = shipping_default;

    populate_address_from_selected_dropdown("billing");
    populate_address_from_selected_dropdown("shipping");
  } else {
    $("existing_billing").update(
      '<option value="">--' +
        get_language_translation("LANG_USE_AN_EXISTING_ADDRESS") +
        "--</option>"
    );
    $("existing_shipping").update(
      '<option value="">--' +
        get_language_translation("LANG_USE_AN_EXISTING_ADDRESS") +
        "--</option>"
    );
    clear_addresses("billing");
    clear_addresses("shipping");
  }
  if (response && typeof response === "object") {
    if (response.methods) {
      for (var instance in response.methods) {
        if (response.methods.hasOwnProperty(instance)) {
          var shipping_method_box = $("shipping_method_via_" + instance);
          //var default_shipping_method = '';
          //if(response.hasOwnProperty('default_shipping') && response.default_shipping.hasOwnProperty(instance))
          //	default_shipping_method = response.default_shipping[instance];
          shipping_method_box.update();
          shipping_method_box.insert(
            '<option value="">-- ' +
              get_language_translation("LANG_OPTS_SELECT_SHIPPING_METHOD") +
              " --</option>"
          );
          for (i = 0; i < response.methods[instance].length; i++) {
            shipping_method_box.insert(
              '<option value="' +
                response.methods[instance][i][0] +
                '" data-class="' +
                (response.methods[instance][i][1] !== null
                  ? response.methods[instance][i][1]
                  : "") +
                '" data-act-as-will-call="' +
                (response.methods[instance][i][3] ? "1" : "0") +
                '">' +
                html_safe(response.methods[instance][i][2]) +
                "</option>"
            );
          }
          const shvalue = shipping_method_box.getAttribute("data-value");
          if (shvalue && !isNan(shvalue)) {
            shipping_method_box.value = shvalue;
          }
          //shipping_method_box.value = default_shipping_method;
        }
      }
    }
    // !!!! optimisation:  Verify that .methods and .default_shipping always occur together, then combine the above and below loops
    if (response.default_shipping) {
      for (instance in response.default_shipping) {
        if (response.default_shipping.hasOwnProperty(instance)) {
          var shipping_method_box = $("shipping_method_via_" + instance);
          const value = shipping_method_box.getAttribute("data-value");
          if (
            shipping_method_box.down(
              'option[value="' + response.default_shipping[instance] + '"]'
            )
          ) {
            if (!value) {
              shipping_method_box.value = response.default_shipping[instance];
            }
          } else {
            shipping_method_box.value = "";
          }
          //if(shipping_method_box.value === '')
          //	shipping_method_box.insert({ top: '<option value="">-- '+get_language_translation('LANG_OPTS_SELECT_SHIPPING_METHOD')+' --</option>' });
        }
      }
    }

    show_hide_shipping();
  }
}

function clear_addresses(addressType) {
  if ($($(addressType + "_container"))) {
    $(addressType + "_container")
      .select(".text")
      .each(function (element) {
        if (element.id != addressType + "_name")
          Form.Element.setValue(element, "");
      });
      if ($(addressType + "_country").selectedIndex > 0) {
        update_states_on_country_change({
          name: address_type + "_name",
          nameval: json.name,
          state_id: address_type + "_state",
          country_id: address_type + "_country",
          state_name: address_type + "[state]",
          zip_id: address_type + "_zip",
          set_state: json.state
        });
      }
    var country = $(addressType + '_country'),
        state   = $(addressType + '_state');

	if (country && country.selectedIndex !== 0 && state) {
		if (country) country.selectedIndex = 0;
		update_state_on_country_change({
			name:       addressType + '_container',
			nameval:    ($(addressType + '_name') || {}).value || '',
			state_id:   state.id,
			country_id: country.id,
			state_name: state.name,
			zip_id:     0,
			set_state:  'AL'
		});
	}
    if (state)   state.selectedIndex   = 0;
  }
}

function populate_address_from_selected_dropdown(address_type) {
  var value = $F($("existing_" + address_type));
  if (value && value.isJSON()) {
    var json = value.evalJSON();
    if (json.country != $(address_type + "_country")) {
      Form.Element.setValue(address_type + "_country", json.country);
      update_states_on_country_change({
        name: address_type + "_name",
        nameval: json.name,
        state_id: address_type + "_state",
        country_id: address_type + "_country",
        state_name: address_type + "[state]",
        zip_id: address_type + "_zip",
        set_state: json.state
      });
    }
    Object.keys(json).each(function (key) {
      if ((element = $(address_type + "_" + key))) {
        if (
          element.tagName != "SELECT" ||
          (element.tagName == "SELECT" && element.options.length > 0)
        ) {
          Form.Element.setValue(element, json[key]);
        }
      }
    });
  } else {
    clear_addresses(address_type);
  }
}
function convert_to_quote() {
  // Temporary disabling of B2B items in itemized orders
  if (has_b2b_items()) {
    open_modal(
      '<p class="notice">' +
        get_language_translation(
          "LANG_THANK_YOU_FOR_PARTICIPATING_IN_THE_B2B_PROGRAM_ETC_MSG"
        ) +
        "</p>",
      {
        ok: true,
        title: get_language_translation("LANG_LABEL_CONVERT_TO_ITEMIZED_ORDER"),
      }
    );
    return false;
  }

  if (
    confirm(
      get_language_translation(
        "LANG_MSG_THIS_WILL_CONVERT_YOUR_ORDER_TO_AN_ITEMIZED_ORDER_IF_YOU_CONTINUE_IT_WILL_NO_LONGER_BE_EDITABLE"
      ) + "."
    )
  ) {
    $("jobs").insert(
      new Element("input", {
        id: "ctq",
        type: "hidden",
        name: "convert_to_quote",
        value: "1",
      })
    );
    MoxForm.Go($("jobs"), customer_validation);
  }
  return false;
}
function validate_min_max(val, min, max) {
  val = frac_to_dec(val);
  min = frac_to_dec(min);
  max = frac_to_dec(max);
  if (val.length == 0) return true;
  val = parseFloat(val);
  if (min.length > 0 && val < parseFloat(min)) return false;
  if (max.length > 0 && val > parseFloat(max)) return false;
  return true;
}
function save_pao_headers(dragged, preserve) {
  var headers = dragged.up().down();
  if (headers == dragged) {
    if (!dragged.up().childElements()[1]) return true;
    if (preserve) headers = dragged.up().childElements()[1];
    else dragged = dragged.up().childElements()[1];
  }
  if (headers.down(3).tagName != "LABEL") {
    // if the headings aren't where they should be...
    dragged
      .childElements()
      .invoke("down", 1)
      .each(function (a, i) {
        if (i == 1) {
          var labels = dragged
            .childElements()[1]
            .childElements()
            .invoke("down");
          var destinations = headers
            .childElements()[1]
            .childElements()
            .invoke("down");
          for (var j = 0; j < labels.length - 1; j++) {
            if (destinations[j]) destinations[j].insert({ before: labels[j] });
          }
        } else headers.children[i].down(1).insert({ before: a });
      });
  }
}
function add_item_rows(trigger, ct, product_set_id, instance) {
  GUI.loss_prevention("jobs");
  var id = "gi_tmpl_" + product_set_id + "_" + instance;
  var template = $(trigger).up(2).previous();
  var where = trigger.up("table").down("tbody");
  if (!GUI.templates[id]) {
    template.setAttribute("id", id);
    if (
      ["tbody", "thead", "tfoot"].indexOf(template.tagName.toLowerCase()) > -1
    ) {
      GUI.templatize(id, 1);
    } else {
      GUI.templatize(id);
    }
  }
  if (where.down("tr")) {
    var first_row_headers = where.down("tr").select(".pao_label");
    var headers_each_row = null;
  } else {
    var headers_each_row = true;
  }
  var len = parseInt(ct);
  if (isNaN(len) || len < 1) len = 1;
  for (var j = 0; j < len; j++) {
    GUI.enumerate(id, where);
    if (headers_each_row === null) {
      if (where.select("tr").last().down(".pao_label")) headers_each_row = true;
      else headers_each_row = false;
    }
    if (headers_each_row) {
      var last_row_headers = where.select("tr").last().select(".pao_label");
      var first_row_headers = where.down("tr").select(".pao_label");
      for (var i = 0; i < last_row_headers.length; i++) {
        var table = where.up("table");
        var cell = last_row_headers[i];
        cell.sorttable_columnindex = i;
        cell.sorttable = table;
        cell.sorttable_tbody = table.tBodies[0];
        cell.sorttable_sortfunction =
          first_row_headers[i].sorttable_sortfunction;
        dean_addEvent(cell, "click", table.click_handler_ref);
      }
    }
  }

  where.select(".p_template").invoke("removeClassName", "p_template");
  where.up(".product").removeClassName("valid").addClassName("stale");

  /**@var {HTMLElement} $product*/
  const $product = where.closest('.product');
  $product?.querySelectorAll('.is_dirty').forEach(e => {
    e.value = true;
  });

  $(where)
    .select("select")
    .each(function (o) {
      get_product_image(o, o.up(".product").getAttribute("data-base"));
    });
  Sortable.create(where, { tag: "tr", onChange: save_pao_headers });
  initLightbox.myLightbox.initialize_more(where);
  theOrder.invalidate("items")
      .invalidate('subtotal')
      .invalidate('total')
      .invalidate('tax')
      .process();
}

function project_has_filled_proposal_line() {
  var filled = false;
  am.$('[name^="cost["]').each(function () {
    if (!/\[(name|price|qty)\]$/.test(am.$(this).attr("name") || "")) return;
    if (String(am.$(this).val() || "").trim() !== "") filled = true;
  });
  return filled;
}

function project_proposal_line_required(elem_id, new_status, orig_status) {
  var elem = $(elem_id);
  if (!elem || elem.getAttribute("data-project_needs_proposal_line") != 1) return false;
  if (new_status == orig_status) return false;

  var allowed = (
    elem.getAttribute("data-statuses_without_proposal_line") || ""
  ).split(",");
  if (allowed.indexOf(new_status) != -1) return false;

  return !project_has_filled_proposal_line();
}

function show_project_proposal_line_required(elem_id, orig_status) {
  var html =
    '<p class="am-dialog__text">' +
    get_language_translation(
      "LANG_MSG_PROJECT_REQUIRES_ONE_PROPOSAL_LINE_TO_LEAVE_BID_STATUS"
    ) +
    "</p>" +
    '<div class="am-dialog__actions">' +
    '<button type="button" class="am-btn am-btn--filled" onclick="Modalbox.hide();">' +
    get_language_translation("LANG_CLOSE") +
    "</button></div>";
  open_modal(html, {
    title: get_language_translation("LANG_TITLE_PROPOSAL_TAB_IS_EMPTY"),
    width: 400,
  });
  $(elem_id).value = orig_status;

  return false;
}

function show_order_status_change_warning(elem_id) {
  if ($(elem_id)) {
    var new_status = $F(elem_id);
    var orig_status = $F("jorder_status");

    if (project_proposal_line_required(elem_id, new_status, orig_status))
      return show_project_proposal_line_required(elem_id, orig_status);
    var white_list = [
      "verified",
      "in progress",
      "completed",
      "on hold",
      "shipped",
    ].indexOf(orig_status);

    if (white_list != -1 && new_status == "bid") {
      var html =
        "<div>" +
        get_language_translation(
          "LANG_YOU_ARE_MOVING_THIS_ORDER_TO_BID_STATUS_FROM_A_STATUS_WHERE_THE_SYSTEM_HAS_ALREADY_ALLOCATED_SUPPLIES_ETC_MSG"
        ) +
        "</div>" +
        '<button class="am-btn am-btn--tonal" onclick="Modalbox.hide();">' +
        get_language_translation("LANG_CLOSE") +
        "</button>";
      open_modal(html, {
        title: get_language_translation("LANG_CHANGING_ORDER_STATUS_TO_BID"),
      });
    }
    //if(white_list != -1 && $('b2b_reseller_agree').value == 1)
    //	$('b2b_reseller_agree').value = 0;

    if (
      $(elem_id)[$(elem_id).selectedIndex].getAttribute(
        "data-ordering_disallowed"
      ) == 1
    )
      show_ordering_disallowed(false, elem_id);
  }
}

function check_min_length_and_validate(elem, min_len, refresh_shipping_price) {
  min_len = min_len || 3;
  if (elem.value.length < min_len) return;
  var id = elem.getAttribute("id");
  if (id) {
    id = "_" + id;
    var err_elem = $(id);
    if (err_elem) err_elem.remove();
    id += "2";
    err_elem = $(id);
    if (err_elem) err_elem.remove();
    err_elem = $("repeat_errors");
    if (err_elem && !err_elem.childElements().length) err_elem.hide();
  }
  if (refresh_shipping_price) theOrder.invalidate("shipping").process();
}

function scroll_within_content_column(el, options) {
  var column = $("content_column");
  if (!column || !column.contains(el)) {
    el.scrollIntoView(options);
    return;
  }
  var el_rect = el.getBoundingClientRect();
  var column_rect = column.getBoundingClientRect();
  var offset = el_rect.top - column_rect.top;
  if (options && options.block === "nearest") {
    if (el_rect.bottom > column_rect.bottom) offset = el_rect.bottom - column_rect.bottom;
    else if (offset > 0) return;
  }
  column.scrollBy({ top: offset, behavior: (options && options.behavior) || "auto" });
}

get_form = Object.extend(
  function (type, trigger, id, rcat, folder_id) {
    // validate the call
    var set = am.$((folder_id ? "#" + folder_id : "") + " #" + type + "set"); // #folder_123 #productset
    if (set.length > 0) {
      set = set.get(0);
    }
    if (!id || !set) {
      if (type === "component" && $("c_name"))
        alert(
          get_language_translation(
            "LANG_YOU_CANNOT_ADD_A_COMPONENT_TO_A_CCOMPONENT"
          ) + "."
        );
      return console.log("Invalid get_form call: " + type);
    }

    var request_uri = "";

    // prevent duplicate requests
    var old_onclick = trigger.onclick;
    trigger.onclick = null;
    if (
      get_form.requests[type][id] &&
      callInProgress(get_form.requests[type][id].transport)
    )
      get_form.requests[type][id].transport.abort();

    // in-place feedback while the attributes fetch runs (it can take seconds):
    // three-dot loading block where the product form will land (m3/_loading.scss)
    var loading_el = null;
    if (set && set.insertAdjacentHTML) {
      var stale_loading = set.querySelector(":scope > .get-form-loading");
      if (stale_loading) stale_loading.remove();
      var loading_label = get_language_translation("LANG_LABEL_LOADING") + "...";
      loading_label = loading_label.charAt(0).toUpperCase() + loading_label.slice(1);
      set.insertAdjacentHTML(
        "beforeend",
        '<div class="am-loading-block get-form-loading">' +
          '<div class="am-loading" aria-hidden="true"><span class="am-loading__dot"></span><span class="am-loading__dot"></span><span class="am-loading__dot"></span></div>' +
          "<span>" + loading_label + "</span>" +
          "</div>"
      );
      loading_el = set.lastElementChild;
      scroll_within_content_column(loading_el, { block: "nearest", behavior: "smooth" });
    }

    // prepare/submit request
    if (GUI.loss_prevention.forms && GUI.loss_prevention.forms.length)
      GUI.loss_prevention.form_changed();
    var params = {};
    if ($("presets")) {
      $$("#presets.presets_order_level_settings .preset").each(function (el) {
        const last_value = el.getAttribute("data-old-value");

        const attr = el.dataset.attr;
        const norm = el.dataset.norm;
        const isB2B = norm && attr && attr !== norm;

        const key = isB2B ? `presets[${norm}]` : el.name;
        //Update param target for b2b products
        params[key] = last_value ?? (typeof $F === "function" ? $F(el) : el.value);
      });

      if (folder_id) {
        const folderPresets = document.querySelector(
          "#" + folder_id + " .saved_folder_settings"
        );
        if (folderPresets) {
          let folderPresetsJson = {};
          try {
            folderPresetsJson = JSON.parse(folderPresets.value);
            Object.entries(folderPresetsJson).forEach(([key, value]) => {
              params["folder_settings[" + key + "]"] = value;
            });
          } catch (e) {
            console.error("Cannot parse folder presets ", e);
          }
        }
      }
    }

    if ($("company_id")) params["company_id"] = $F("company_id");
    if (rcat == 1) {
      params["id"] = id;
      params["type"] = type;
      request_uri = "ajax/orders/get_rcatalog_attributes/";
    } else {
      params[get_form.ajax_key[type]] = id;
      request_uri = ["ajax/orders/get", type, "attributes/"].join("_"); // e.g. get_product_attributes, get_component_attributes
    }

    const queryParams = new URLSearchParams(document.location.search);
    if (queryParams.get("dev") === "1") {
      params["debug_attrs"] = true;
    }
    var rum_t0 = window.am_rum_now ? am_rum_now() : Date.now();
    get_form.requests[type][id] = new Ajax.Request(request_uri, {
      method: "post",
      parameters: params,
      // RUM custom event (DEV-12921): the attributes fetch is the other slow order-
      // form path excluded from RUM's http telemetry. Status 0 = superseded (aborted
      // above) and is not reported.
      onComplete: function (ret) {
        if (ret && ret.status && window.am_rum_event) {
          am_rum_event("mrp.get_form", {
            ms: Math.round(am_rum_now() - rum_t0),
            type: type,
            rcatalog: rcat == 1,
            status: ret.status,
          });
        }
      },
      onException: function (request, exception) {
        if (loading_el) loading_el.remove();
        console.log(exception);
        console.log(
          [
            "Ajax exception (get_form):",
            exception.message,
            "in",
            exception.fileName,
            "line #" + exception.lineNumber,
          ].join(" ")
        );
        check_remove_catalog_access();
      },
      onFailure: function () {
        if (loading_el) loading_el.remove();
      },
      onSuccess: function (ret) {
        if (loading_el) loading_el.remove();
        // DEV-14084: nothing below may run on a response that is not ours — the
        // branches after this inject responseText as HTML.
        var rejection = order_form_response_rejection(ret.responseText);
        if (rejection === "unavailable") {
          var title = get_language_translation("LANG_PRODUCT_UNAVALIABLE");
          var html =
            '<div class="notice">' +
            get_language_translation(
              "LANG_THAT_PRODUCT_IS_PRESENTLY_UNAVAIL_SORRY_FOR_THE_INCONVENIENCE"
            ) +
            ".</div>";
          open_modal(html, { title: title, ok: true });
          return;
        }
        if (rejection) {
          // A whole HTML page (a redirect, a login screen, an error document)
          // where a fragment belongs. Say so loudly and inject NOTHING: the
          // user's typed input is still in the form and must survive this.
          if (window.am_rum_event) {
            am_rum_event("mrp.get_form_rejected", {
              reason: rejection,
              type: type,
              status: ret && ret.status ? ret.status : 0,
            });
          }
          console.error(
            "get_form: refused a " + rejection + " response from " + request_uri,
            ret && ret.status
          );
          // Literals, not new LANG_ keys: get_language_translation() returns the
          // KEY itself when one is missing (scripts/lib/allmoxy.js:286), so an
          // unseeded key would show the user "LANG_MSG_...". Same reasoning as the
          // literal fallbacks in the embed controllers — the key can take over
          // later, the message has to be readable today.
          open_modal(
            '<div class="notice">This item could not be loaded, so nothing was ' +
              "added to the order. Your typed details are still here — please try " +
              "again, and if it keeps happening, tell support.</div>",
            { title: "Could not load this item", ok: true }
          );
          return;
        }
        if ($("cart_queue")) {
          force_order_cart_up();
          $("cart_product").update(ret.responseText);
          $("new_product").hide();
          $("cart_queue").show();
          $("cart_product").setAttribute("data-type", type);
          $("cart_product").setAttribute("data-id", id);
          var item_list = $("cart_product").down("table.sortable");
          var posArray = $("cart_queue").positionedOffset();
          $("content_column").scrollTop = posArray[1];

          if (item_list) sorttable.makeSortable(item_list);
          get_form.callback[type]($("cart_product").down(".product"), id, true);
        } else {
          add_product_to_order_form(set, ret.responseText);
          var kids = set.childElements();
          var latest = kids[kids.length - 1];
          get_form.callback[type](latest, id);
          var posArray = $(latest).positionedOffset();
          if (latest) {
            scroll_within_content_column(latest);
          }
          // $('content_column').scrollTop = posArray[1];
          //latest.scrollTo().down('.dh').observe('mousedown', order.mousedown);
          var item_list = latest.down("table.sortable");
          if (item_list) sorttable.makeSortable(item_list);

          if (folder_id) {
            const order_status = am.$("#jorder_status").val();
            if (order_status !== "bid" && order_status !== undefined) {
              //show 'Add Product' button
              am.$(`#${folder_id} .order-folder-footer`).show();

              //hide category selector
              am.$(`#${folder_id} #new_product`).hide();
            }
          }
        }
        if (trigger) trigger.onclick = old_onclick;

        fetchProductAttributeOptions();
        setTimeout(lazyImageLoad, 10);
        setTimeout(lazyloadBackgroundImages, 10);

        const productDiv = latest && (latest.matches('.product') ? latest : latest.closest('.product'));
        const productId = productDiv && productDiv.id ? productDiv.id : null;
        if(productId != null) {
          setTimeout(() => { on_click_ols_update_existing_products(folder_id,productId,true); }, 10);
        }

      },
    });
    // Always the gated orders endpoint. The old else-branch fell back to
    // ajax/components/get_cats/ (the catalog-admin picker, which applies NO
    // company_exclusive/cat_exclusive filtering) whenever the clicked tile was
    // not a descendant of #jobs - the folder/room rewrite made that common,
    // leaking hidden categories to unapproved visitors (DEV-12810).
    catsel(undefined, undefined, folder_id);
  },
  {
    ajax_key: {
      supply: "item_id",
      product: "product_id",
      component: "component_id",
    },
    callback: {
      supply: function (supply, id, in_cart) {
        supply.addClassName("stale");
        add_shipping_group(supply.getAttribute("data-rsource"));
        initLightbox.myLightbox.initialize_more(supply);
        theOrder.invalidate("items").invalidate("shipping").process();

        check_remove_catalog_access();
      },
      component: function (component, arg_not_used, in_cart) {
        add_shipping_group(component.getAttribute("data-rsource"));
        // only initialize togglers if not already initialized.
        var togglers = component.select(".toggler");
        if (togglers.length && !component.observed) {
          component.observed = true;
          togglers.each(function (toggler) {
            toggler.observe("click", function (ev) {
              component_toggler(ev, toggler);
            });
          });
          // if (in_cart) initLightbox.myLightbox.initialize_more("cart_product");
          // else initLightbox.myLightbox.initialize_more("componentset");
        }
        initLightbox.myLightbox.initialize_more(component);

        // only initialize selects if not already initialized.
        var selects = component.select("select");
        if (
          selects.length &&
          !selects[0].up().previous().childElements.length
        ) {
          selects.each(function (o) {
            get_product_image(o, o.up(".component").getAttribute("data-base"));
          });
        }

        // get prices on all contents of the component (which, in turn, update the component price)
        var productset = component.down(".c_productset");
        component.down(".dh .error").hide().update();
        productset.childElements().each(function (prod) {
          prod.addClassName("stale");
        });
        initLightbox.myLightbox.initialize_more(productset);
        component
          .down(".c_supplyset")
          .childElements()
          .each(function (supply) {
            supply.addClassName("stale");
          });
        theOrder.invalidate("items").invalidate("shipping").process();

        check_remove_catalog_access();
      },
      product: function (product, id, in_cart) {
        try {
          add_shipping_group(product.getAttribute("data-rsource"));
        } catch (err) {
          console.log("err", err);
          console.log("product", product);
        }

        var tr = product.down(".p_template");
        if (tr) {
          tr.removeClassName("p_template");
          var tbody = tr.up(),
            thead = tbody.previous();
          GUI.templatize(tbody.id, 1);
          if (thead.tagName.toUpperCase() == "THEAD") {
            thead.insert({ after: new Element("tbody", { id: tbody }) });
            thead = thead.next();
          }
          Sortable.create(thead, { tag: "tr", onChange: save_pao_headers });
        }
        product.addClassName("stale");
        product.select("select").each(function (o) {
          get_product_image(o, o.up(".product").getAttribute("data-base"));
        });
        initLightbox.myLightbox.initialize_more(product);
        theOrder.invalidate("items").invalidate("shipping").process();
        //get_price('product', product, id, product.getAttribute('data-rtype'));

        check_remove_catalog_access();
      },
      _: 0,
    },
    requests: { supply: [], product: [], component: [] },
    _: 0,
  }
);

function component_catsel(id) {
  var params = { id: id };
  var order_id = $("jobs") ? $("jobs").getAttribute("data-order_id") : null;
  if (order_id) params["order_id"] = order_id;
  new Ajax.Request("ajax/components/get_cats/", {
    parameters: params,
    onSuccess: function (ret) {
      $("new_product").update(ret.responseText);
      product_quick_search_init();
      MoxForm("product_quick_search");
      lazyImageLoad();
    },
  });
  return false;
}
function components_js(ele, unique) {
  var kids = $("componentset").childElements();
  var tbody = "gi_tmpl_" + unique,
    tr = "gi_tmpl_" + unique + "_~id~";
  if ($(tr)) {
    var thead = $(tbody).previous();
    GUI.templatize(tbody, true);
    if (thead.tagName.toUpperCase() == "THEAD") {
      thead.insert({ after: new Element("tbody", { id: tbody }) });
      thead = thead.next();
    } else thead.id = tbody;
  }
  kids[kids.length - 1].select("select").each(function (o) {
    o.onchange();
  });
  var toggler = $("toggler_" + unique);
  var alt_toggler = $("alt_toggler_" + unique);
  if (toggler) {
    alt_toggler.onclick = toggler.onclick = function (ev) {
      component_toggler(ev, unique);
    };
  }
  catsel();
  initLightbox.myLightbox.initialize_more("componentset");
  Sortable.create("componentset", { tag: "div", handle: "dh" });
}

function toggle_order_info() {
  GUI.blind_toggle("the_rest_of_the_form", $("show_hide_order_info"));
  return false;
}

function force_order_info_down() {
  var element = $("the_rest_of_the_form");
  if (element) if (!element.visible()) toggle_order_info();
}

function toggle_billing_container() {
  GUI.blind_toggle("billing_container", $("show_hide_order_billing_address"));
  return false;
}

function toggle_shipping_top_container() {
  GUI.blind_toggle(
    "shipping_top_container",
    $("show_hide_order_shipping_address")
  );
  return false;
}

function show_ordering_disallowed(customer_prompt, elem_id) {
  var title = "";
  var html = "";

  if (customer_prompt) {
    title = get_language_translation(
      "LANG_THIS_COMPANY_IS_CURRENTLY_UNABLE_TO_TAKE_ORDERS"
    );
    html =
      "<div>" +
      get_language_translation(
        "LANG_ORDERS_CANNOT_BE_PLACED_AS_THIS_COMPANY_HASENT_FINISHED_SETTING_UP_THEIR_CATALOG"
      ) +
      "</div>" +
      '<button class="am-btn am-btn--tonal" onclick="Modalbox.hide();">' +
      get_language_translation("LANG_CLOSE") +
      "</button>";
    open_modal(html, { title: title });
  } else {
    title = get_language_translation(
      "LANG_YOUR_COMPANY_IS_CURRENTLY_UNABLE_TO_TAKE_ORDERS"
    );
    html =
      "<div>" +
      get_language_translation(
        "LANG_IN_ORDER_TO_SAVE_THIS_ORDER_YOU_NEED_TO_FINISH_SETTING_UP_ONLINE_ORDERING"
      ) +
      "</div>" +
      '<button class="am-btn am-btn--tonal" onclick="Modalbox.hide();">' +
      get_language_translation("LANG_CLOSE") +
      "</button>";
    open_modal(html, { title: title });
    $(elem_id).value = "bid";
  }

  return false;
}

function force_billing_address_entry_down() {
  var element = $("billing_container");
  if (element) if (!element.visible()) toggle_billing_container();
}

function force_shipping_address_entry_down() {
  //if($('shipping_container') && $('shipping_container').visible() && $('shipping_container').down('h2.open'))
  //	GUI.blind_toggle('shipping_addr', $('shipping_container').down('h2.open'));
  var element = $("shipping_top_container");
  if (element) if (!element.visible()) toggle_shipping_top_container();
}

function toggle_order_cart() {
  GUI.blind_toggle("cart_content", "cart_toggler", { duration: 0.5 });
  return false;
}

function force_order_cart_down() {
  var element = $("cart_content");
  if (element) if (!element.visible()) toggle_order_cart();
}

function force_order_cart_up() {
  var element = $("cart_content");
  if (element) if (element.visible()) toggle_order_cart();
}

/**
 * Add product to order from, either directly from catalog listing or from cart queue.
 * @param set    object  Product set element where product should be isnerted.
 * @param mixed  element Element or HTML to insert.
 */
/**
 * DEV-14084: may this response be painted into the order form?
 *
 * The attributes fetch injects its response as raw HTML. On 2026-10-23 that
 * response was Apache's generic "302 Found" redirect page, which got rendered
 * inside a line's price area; the order would not save and the description the
 * user had typed was lost without a word. The handler's only protection was a
 * blacklist of three strings, and the redirect body matched none of them.
 *
 * A blacklist is the wrong shape here — it only ever knows the failures we have
 * already seen (the "login-page" entry is there because a login page came back
 * once before). The structural rule is what holds: these endpoints return a
 * FRAGMENT, so anything that is a whole HTML document is wrong no matter what
 * generated it. That one check covers Apache's redirect page, our own login and
 * maintenance pages, and every error document we have not met yet.
 *
 * Returns null when the body is safe to inject, otherwise a short reason:
 *   'unavailable' - the three known product-unavailable answers, handled as before
 *   'document'    - a whole HTML page where a fragment belongs
 *   'empty'       - nothing to inject
 *
 * Pure string in, string/null out, no DOM: tests/js/check-order-form-response.js
 * reads it straight out of this file.
 *
 * @param {string} body responseText from an order-form fetch
 * @returns {string|null}
 */
function order_form_response_rejection(body) {
  if (typeof body !== "string" || !body.trim().length) return "empty";
  // Preserved exactly as they were, so nothing handled today changes behavior.
  if (
    body === "409" ||
    body.indexOf("Find: No matchingProductrecords found") !== -1 ||
    body.indexOf("login-page") !== -1
  ) {
    return "unavailable";
  }
  // A fragment never carries a doctype or an <html>/<head> root. Checked on the
  // opening stretch only: product markup may legitimately contain those strings
  // further in (help text, a template preview), and matching anywhere would
  // reject good responses — which is worse than the bug this guards.
  var head = body.slice(0, 500).toLowerCase();
  if (
    head.indexOf("<!doctype") !== -1 ||
    head.indexOf("<html") !== -1 ||
    head.indexOf("<head>") !== -1
  ) {
    return "document";
  }
  return null;
}

function add_product_to_order_form(set, element) {
  var kids = set.childElements();
  if (kids.length) kids[kids.length - 1].insert({ after: element });
  else set.update(element);
  Sortable.create(set, { tag: "div", handle: "dh" });
  theOrder.update_folders_data();
  theOrder.invalidate("items").process();
  show_dev_tools();
}

// is_dev_mode() moved to site.js so it's available in all bundles

function show_dev_tools() {
  if (is_dev_mode()) {
    am.$("[data-dev-tool]").show();
  }
}

// Force highlighting off if a non-product/-shipping_method is clicked
function non_shipping_group_clicked(event) {
  try {
    if (
      !event.target.hasClassName("shipping_method") &&
      !event.target.closest("div.product")
    )
      highlight_shipping_group();
  } catch (err) {}
}

function highlight_shipping_group(instance) {
  //if(!$$('input[name=has_ritems]').length) // If there are no remote items, do not use group higlighting
  if ($$(".shipping_method_set").length < 2) {
    // If there are not multiple shipping sources, do not use group highlighting
    $$(".shipping_group_highlight").each(function (item) {
      item.removeClassName("shipping_group_highlight");
    });
    $$(".shipping_method_set").each(function (method_set) {
      method_set.removeClassName("shipping_group_highlight");
    });
    return;
  }

  $$(".shipping_method_set").each(function (method_set) {
    if (method_set.getAttribute("data-instance") === instance)
      method_set.addClassName("shipping_group_highlight");
    else method_set.removeClassName("shipping_group_highlight");
  });
  var sets = ["componentset", "productset", "supplyset"];
  for (var i = 0; i < 3; i++) {
    $$("#" + sets[i] + " .product").each(function (item) {
      if (item.getAttribute("data-rsource") === instance)
        item.addClassName("shipping_group_highlight");
      else item.removeClassName("shipping_group_highlight");
    });
  }
}

function add_shipping_group(instance) {
  // Force local shipping methods when NOT using dropshipping
  if ($("b2b_dropship") && $("b2b_dropship").value == 0) {
    instance = "LOCAL";
  }
  if (!$("shipping_method_set_" + instance)) {
    var request_uri = "ajax/orders/get_shipping_method_set/";
    var b2bdropship = "";
    if ($("b2b_dropship") && $("b2b_dropship").value)
      b2bdropship = $("b2b_dropship").value;
    var params = {
      order_id: $("jobs").getAttribute("data-order_id"),
      instance: instance,
      b2b_dropship: $("b2b_dropship").value,
    };
    if ($("company_id") && $F("company_id"))
      params.company_id = $F("company_id");
    //if($('existing_contact_id') && $F('existing_contact_id'))
    //	params.contact_id = $F('existing_contact_id');
    if ($("is_public")) params.is_public = 1;
    new Ajax.Request(request_uri, {
      parameters: params,
      onSuccess: function (ret) {
        // Extra check here for those edge cases that check for the shipping group again before the previous request finishes
        if ($("shipping_method_set_" + instance)) return;
        if (ret.responseJSON && ret.responseJSON.html) {
          if (instance === "LOCAL")
            $("remote_shipping_info").insert({ before: ret.responseJSON.html });
          else {
            $("remote_shipping_info").show();
            $("shipping_method_pool").insert(ret.responseJSON.html);
          }
          $("no_shipping_methods").hide();
          if (!$("shipping_method_via_" + instance).childElements().length)
            $("shipping_method_via_" + instance).insert(
              "<option>!! " +
                get_language_translation(
                  "LANG_NO_ACTIVE_SHIPPING_METHODS_AVAIL_ALL_CAPS"
                ) +
                " !!</option>"
            );
          shipping_method_changed();
        } else if (ret.responseText) {
          if (ret.responseText.includes("login-page"))
            open_modal(
              '<div class="error"><p>' +
                get_language_translation(
                  "LANG_ERROR_OCCURED_WHILE_TRYING_TO_RETRIEVE_SHIPPING_METHODS"
                ) +
                "<p></p>" +
                get_language_translation("LANG_PLEASE_CONTACT_SUPPORT") +
                ".</p></div>",
              { title: get_language_translation("LANG_GET_SHIPPING_METHOD") }
            );
          else
            open_modal(
              '<div class="error"><p>' +
                get_language_translation(
                  "LANG_THE_FOLLOWING_ERROR_OCCURED_WHILE_TRYING_TO_RETRIEVE_SHIPPING_METHODS"
                ) +
                ':</p><p class="bold" style="margin: 10px 0;">' +
                ret.responseText +
                "</p><p>" +
                get_language_translation("LANG_PLEASE_CONTACT_SUPPORT") +
                ".</p></div>",
              { title: get_language_translation("LANG_GET_SHIPPING_METHOD") }
            );
        } else {
          open_modal(
            '<div class="error"><p>' +
              get_language_translation(
                "LANG_THE_FOLLOWING_ERROR_OCCURED_WHILE_TRYING_TO_RETRIEVE_SHIPPING_METHODS"
              ) +
              ':</p><p class="bold" style="margin: 10px 0;">' +
              ret.status +
              ": " +
              ret.statusText +
              "</p><p>" +
              get_language_translation("LANG_PLEASE_CONTACT_SUPPORT") +
              ".</p></div>",
            { title: get_language_translation("LANG_GET_SHIPPING_METHOD") }
          );
        }
      },
    });

    /* I can't think of why I made this rule except to make B2B logic a helluva lot easier.
		// Disallow pick-up methods if order contains B2B items
		if(instance !== 'LOCAL')
		{
			var local_group = $('shipping_method_via_LOCAL');
			if(local_group)
			{
				if(local_group.down('[value=0]'))
				{
					if(local_group.value == '0')
					{
						if(!local_group.down('[value=""]'))
							local_group.insert('<option value="">-- '+get_language_translation('LANG_OPTS_SELECT_SHIPPING_METHOD')+' --</option>');
						else
							local_group.value = '';
						//shipping_method_changed();
					}
					local_group.down('[value=0]').hide().disabled = true;
				}
			}
		}
		*/
  }
}

function remove_shipping_group(instance) {
  var remove = true;
  var sets = ["componentset", "productset", "supplyset"];

  // Force local shipping methods when NOT using dropshipping
  if ($("b2b_dropship") && $("b2b_dropship").value == 0) return;

  if (instance === "LOCAL" && $("itemized_order")) return;

  for (var i = 0; i < 3; i++) {
    $$("#" + sets[i] + " .product").each(function (item) {
      if (item.getAttribute("data-rsource") === instance) {
        remove = false;
        return false;
      }
    });
    if (!remove) return;
  }

  if ($("shipping_method_set_" + instance)) {
    $("shipping_method_set_" + instance).remove();
    detect_no_shipping_methods();
  }

  /*
	// Allow pick-up method if order does NOT contain B2B items
	if(instance !== 'LOCAL')
	{
		var local_group = $('shipping_method_via_LOCAL');
		if(local_group && $$('.shipping_method').length == 1)
		{
			if(local_group.down('[value=0]'))
				local_group.down('[value=0]').show().disabled = false;
		}
	}
	*/
  theOrder.tax_rate_valid = false;
}

function detect_no_shipping_methods() {
  var method_group_count = $$(".shipping_method").length;
  if (method_group_count) {
    $("no_shipping_methods").hide();
    /* This block should be unnecessary
		if(method_group_count == 1)
		{
			// Clear group highlights
			$$('.shipping_method_set').each(function(method_set)
			{
				method_set.removeClassName('shipping_group_highlight');
			});
			var sets = ['componentset', 'productset', 'supplyset'];
			for(var i = 0; i < 3; i++)
			{
				$$('#' + sets[i] +' .product').each(function(item)
				{
					item.removeClassName('shipping_group_highlight');
				});
			}
		}
		*/
    if (method_group_count == 1 && $("shipping_method_set_LOCAL")) {
      $("remote_shipping_info").hide();
      if ($("shipping_method_via_LOCAL").value == 0)
        $("shipping_container").hide();
    }
  } else {
    $("no_shipping_methods").show();
    $("remote_shipping_info").hide();
  }
}

function save_order_clicked(show_disclaimer, submit_action) {
  if (window.busy_validating) {
    setTimeout(function () {
      save_order_clicked(show_disclaimer, submit_action);
    }, 250);
    return;
  }

  if (show_disclaimer) {
    if (
      $("status").value != "bid" &&
      $("status").value != "ordered" &&
      $("b2b_reseller_agree").value != 1
    ) {
      var has_b2b = false;
      var sets = ["componentset", "productset", "supplyset"];
      var instances = [];
      for (var i = 0; i < 3; i++) {
        $$("#" + sets[i] + " .product").each(function (item) {
          var instance = item.getAttribute("data-rsource");
          if (instance !== "LOCAL") {
            has_b2b = true;
            instances.push(instance);
          }
        });
      }

      if (has_b2b) {
        instances = instances.filter(array_filter_unique);
        open_modal(
          {
            href: "modals/b2b_order_agreement_reminder/" + submit_action + "/",
            title: get_language_translation(
              "LANG_REMOTE_CATALOG_RESELLER_DISCLAMER_AND_AGREEMENT"
            ),
          },
          {
            method: "post",
            params: { go_name: "jobs", instances: JSON.stringify(instances) },
            width: 605,
          }
        );
      } else save_order_clicked(false, submit_action);
      return;
    }
  }
  var validation;
  if (
    submit_action == "continue_submit" &&
    typeof continue_submit === "function"
  )
    validation = continue_submit;
  //if(submit_action == 'customer_validation')
  else validation = customer_validation;
  return MoxForm.Go($("jobs"), validation);
}

function save_order_clicked2(show_disclaimer, go_name) {
  if (show_disclaimer) {
    if (
      $("status").value != "bid" &&
      $("status").value != "ordered" &&
      $("b2b_reseller_agree").value != 1
    ) {
      var has_b2b = false;
      var instances = [];
      $$("#shipping_method_pool .shipping_method_set").each(function (set) {
        var instance = set.getAttribute("data-instance");
        if (instance !== "LOCAL") {
          has_b2b = true;
          instances.push(instance);
        }
      });

      if (has_b2b) {
        instances = instances.filter(array_filter_unique);
        open_modal(
          {
            href: "modals/b2b_order_agreement_reminder/null/",
            title: get_language_translation(
              "LANG_REMOTE_CATALOG_RESELLER_DISCLAMER_AND_AGREEMENT"
            ),
          },
          {
            method: "post",
            params: { go_name: go_name, instances: JSON.stringify(instances) },
            width: 605,
          }
        );
      } else save_order_clicked2(false, go_name);
      return;
    }
  }
  return MoxForm.Go($(go_name), right_side_of_form);
}

function b2b_i_agree_clicked(validation, go_name) {
  var all_checked = true;
  $("MB_window")
    .select("input.b2b_agreement")
    .each(function (el) {
      if (!el.checked) {
        all_checked = false;
        return false;
      }
    });
  if (all_checked) {
    $("b2b_reseller_agree").value = 1;
    Modalbox.hide();
    if (go_name === "jobs") return MoxForm.Go($(go_name), validation);
    else return MoxForm.Go($(go_name), right_side_of_form);
  } else {
    $("b2b_agreement_need_confirmation").show();
    $("MB_content").scrollTop = $("MB_content").scrollHeight;
    return false;
  }
}

function has_b2b_items() {
  var has_b2b = false;
  var sets = ["componentset", "productset", "supplyset"];
  for (var i = 0; i < 3; i++) {
    $$("#" + sets[i] + " .product").each(function (item) {
      if (item.getAttribute("data-rsource") !== "LOCAL") {
        has_b2b = true;
        return false;
      }
    });
  }
  return has_b2b;
}

function get_b2b_import(mode) {
  new Ajax.Request("ajax/orders/get_b2b_import/" + mode + "/", {
    onSuccess: function (ret) {
      if (ret.responseJSON.length) {
        ret.responseJSON.each(function (forms) {
          if (forms.Product && forms.Product.length) {
            forms.Product.each(function (form) {
              const folder_id = am.$(form).find(".folder_id")?.val();
              if (folder_id) {
                am.$(`#folder_${folder_id} #productset`).append(form);
              } else {
                $("productset").insert(form);
              }
            });
          }

          if (forms.Supply && forms.Supply.length) {
            forms.Supply.each(function (form) {
              const folder_id = am.$(form).find(".folder_id")?.val();
              if (folder_id) {
                am.$(`#folder_${folder_id} #supplyset`).append(form);
              } else {
                am.$("#supplyset").append(form);
              }
            });
          }

          if (forms.hasOwnProperty("errors") && Array.isArray(forms.errors)) {
            forms.errors.forEach((e) => {
              add_notification(e, "danger");
            });
          }
        });
        $("products_section")
          .select(".product")
          .each(function (product) {
            get_form.callback["product"](
              product,
              product.getAttribute("data-rid")
            );
            add_shipping_group(product.getAttribute("data-rsource"));
            var item_list = product.down("table.sortable");
            if (item_list) sorttable.makeSortable(item_list);
          });
        theOrder.invalidate("items").process();
        Sortable.create($("productset"), { tag: "div", handle: "dh" });
      }
    },
    onFailure: function (ret) {
      console.log(ret);
    },
  });
}

// Use of this function appears to have been weeded out; maybe wait until after v1.5.33 is released to delete it.
function get_price() {
  console.log("Call to removed function get_price() !!!!!");
  console.log(arguments);
  console.log(new Error().stack);
}

function order_item_changed(type, container) {
  // mark fields as dirty to force the order to update
  am.$(container)
    .find(".is_dirty")
    .each(function (i, el) {
      el.value = true;
    });
  if (type === "product" || type === "supply") {
    container
      .removeClassName("valid")
      .addClassName("stale")
      .addClassName("isDirty");
    theOrder.invalidate("items").process();
  } else if (type === "component") {
    var productset = container.down(".c_productset");
    container.down(".dh .error").hide().update();
    productset.childElements().each(function (prod) {
      prod.addClassName("stale");
    });
    container
      .down(".c_supplyset")
      .childElements()
      .each(function (supply) {
        supply.addClassName("stale");
      });
    theOrder.invalidate("items").process();
  }
}

function ask_for_order_discount_removal() {
  return show_dialog({
    title: get_language_translation("LANG_ORDER_DISCOUNT"),
    text: get_language_translation(
      "LANG_KEEP_ORIGINAL_ORDER_DISCOUNT_ON_NEW_ORDER"
    ),
    primaryButton: {
      text: get_language_translation("LANG_OPT_YES"),
      class: "am-btn am-btn--filled",
      style: "flex:1",
    },
    cancelButton: {
      text: get_language_translation("LANG_OPT_NO"),
      show: true,
      style: "flex:1",
    },
    width: 480,
  });
}

function disable_order_submission_buttons() {
  var buttons = [
    "convert_to_quote",
    "duplicate_order",
    "goto_visual_designer",
    "modal_submit2",
    "order_submit2",
  ];
  var i = 0;
  for (i = 0; i < buttons.length; i++) {
    if ($(buttons[i])) {
      if (!$(buttons[i]).hasAttribute("data-old_attr_onclick"))
        $(buttons[i]).setAttribute(
          "data-old_attr_onclick",
          $(buttons[i]).getAttribute("onclick")
        );
      $(buttons[i]).setAttribute("onclick", "return false;");
      if ($(buttons[i]).hasAttribute("href")) {
        if (!$(buttons[i]).hasAttribute("data-old_attr_href"))
          $(buttons[i]).setAttribute(
            "data-old_attr_href",
            $(buttons[i]).getAttribute("href")
          );
        $(buttons[i]).setAttribute("href", "javascript:void(0);");
      }
    }
  }
}

function re_enable_order_submission_buttons() {
  var buttons = [
    "convert_to_quote",
    "duplicate_order",
    "goto_visual_designer",
    "modal_submit2",
    "order_submit2",
  ];
  var i = 0;
  for (i = 0; i < buttons.length; i++) {
    if ($(buttons[i])) {
      if ($(buttons[i]).hasAttribute("data-old_attr_onclick"))
        $(buttons[i]).setAttribute(
          "onclick",
          $(buttons[i]).getAttribute("data-old_attr_onclick")
        );
      if ($(buttons[i]).hasAttribute("data-old_attr_href"))
        $(buttons[i]).setAttribute(
          "href",
          $(buttons[i]).getAttribute("data-old_attr_href")
        );
    }
  }
}


function clear_order_form_tax_calc()
{
	// DEV-12392: the recalc placeholder is a skeleton line now (canon totals loading state)
	var is_calc = function(el){ return el && (el.innerHTML.indexOf('am-skeleton') !== -1 || el.innerHTML == 'Calculating...'); };
	if(is_calc($('gt_taxes')))
		$('gt_taxes').update('-');
	if(is_calc($('gt_gst_taxes')))
		$('gt_gst_taxes').update('-');
	if(is_calc($('gt_pst_taxes')))
		$('gt_pst_taxes').update('-');
}

function check_for_blank_attributes() {
  var err_cnt = 0;
  $$("input[data-required=1]").each(function (
    el // `select` attributes currently don't support `required` flag
  ) {
    if (el.value.trim() === "") {
      var name = el.getAttribute("data-display_name");
      el.up(".product")
        .select(".error_container")
        .pop()
        .update(
          '<div class="error">' +
            (name ? name : get_language_translation("LANG_LABEL_ATTRIBUTE")) +
            " " +
            get_language_translation("LANG_CANNOT_BE_BLANK") +
            ".</div>"
        )
        .show();
      err_cnt++;
      var component = el.up(".component");
      if (component)
        component
          .down(".dh")
          .down(".error")
          .update(
            "<b>" +
              get_language_translation(
                "LANG_THERE_ARE_ERRORS_IN_THIS_COMPONENT"
              ) +
              ".</b>"
          )
          .show();
    }
  });
  return err_cnt;
}

function clone_order_b2b_supplier_prompt() {
  open_modal(
    "<p>" +
      get_language_translation(
        "LANG_THIS_IS_A_B2B_SUPPLIER_ORDER_PAIRED_WITH_A_REMOTE_B2B_RESELLER_ORDER_ETC_MSG"
      ) +
      "</p>" +
      '<div><button type="button" class="am-btn am-btn--filled MB_focusable" onclick="clone_order_b2b_supplier_yes(); Modalbox.hide();"><span><i class="fa fa-copy"></i>' +
      get_language_translation("LANG_LABEL_DUPLICATE_THIS_ORDER") +
      "</span></button>" +
      '<button type="button" class="am-btn am-btn--tonal MB_focusable" onclick="Modalbox.hide();">' +
      get_language_translation("LANG_BTN_CANCEL") +
      "</button></div>",
    { title: get_language_translation("LANG_LABEL_DUPLICATE_THIS_ORDER") }
  );
}

function clone_order_b2b_supplier_yes() {
  var button = $("duplicate_order");
  var cmd = button.getAttribute("data-onclick");
  if (cmd) button.setAttribute("onclick", cmd);
  else button.setAttribute("onclick", null);
  button.click();
}

// Omit argument to lock entire order form (customer view on paid order) or specify instance to only lock part of order form (paid B2B portion)
function lock_order_form(instance, status) {
  var inst_comps = instance
    ? 'div[id^="component_"][id$="_' + instance + '"]'
    : "";
  var inst_prods = instance
    ? 'div[id^="product_"][id$="_' + instance + '"]'
    : "";
  var inst_sups = instance ? 'div[id^="supply_"][id$="_' + instance + '"]' : "";
  var inst_all = instance ? 'div[id$="_' + instance + '"]' : "";
  var lock_shipping = false;

  if (!status)
    // If status isn't declared, assume this is a paid order and therefore locked
    lock_shipping = true;
  else if (["completed", "shipped"].indexOf(status) > -1) lock_shipping = true;

  $$(
    "#componentset " +
      inst_comps +
      " :input, #productset " +
      inst_prods +
      " :input, #supplyset " +
      inst_sups +
      " :input"
  ).each(function (
    element // Previously handled here but now handled elsewhere:  #product_quick_search_query, #the_rest_of_the_form :input
  ) {
    if (!["name", "description", "ddd"].include(element.getAttribute("name"))) {
      element.observe("focus", notice_order_cannot_change);
      if (element.nodeName === "SELECT") {
        element.stopObserving("onchange");
      } else if (
        element.nodeName === "INPUT" ||
        element.nodeName === "TEXTAREA"
      ) {
        element.setAttribute("readonly", 1);
        element.setStyle({ cursor: "not-allowed" });
        if (element.getAttribute("type") === "checkbox")
          element
            .up("label")
            .hide()
            .insert({
              after:
                '<label><span class="cb2_' +
                (element.checked ? "1" : "0") +
                '"></span>' +
                get_textnode_text(element.up("label")) +
                "</label>",
            });
      }
    }
  });

  // In-form catalog browser/search
  if (!instance) {
    $("new_product")
      .hide()
      .insert({
        after:
          '<p class="mtop10 notice">' +
          get_language_translation(
            "LANG_PAYMENTS_HAVE_ALREADY_BEEN_MADE_ON_THIS_ORDER_THERFORE_PRODUCTS_AND_SHIPPING_CANNOT_BE_CHANGED"
          ) +
          "</p>",
      });
  }

  // Duplicate/Delete buttons
  $$(
    "#products_section " +
      inst_all +
      " i.fa-trash, #products_section " +
      inst_all +
      " i.fa-copy"
  ).each(function (element) {
    element.setStyle({ visibility: "hidden" });
  });

  // Add Row buttons
  $$("#products_section " + inst_prods + " i.fa-plus-circle").each(function (
    element
  ) {
    var ay = element.up("a");
    if (ay && ay.getAttribute("onclick").indexOf("add_item_rows") > -1)
      element.up("a").remove();
  });

  // Remove ability to change product option selection via attribute thumbnail
  $$(inst_prods + " .pao_pic").each(function (element) {
    element.setAttribute("data-no_litebox_nav", 1);
  });

  // Shipping Methods
  $$(instance ? "#shipping_method_via_" + instance : ".shipping_method").each(
    function (element) {
      element.setStyle({ cursor: "not-allowed" });
      isolate_selected_option(element);
      element.setAttribute("onclick", "notice_order_cannot_change();");
    }
  );

  if (lock_shipping) {
    // Shipping Address.  Locking even if order is only partially locked because we do not support multiple shipping destinations!
    $("existing_shipping").hide();
    var shipping_same_as_billing = $("shipping_same_as_billing");
    shipping_same_as_billing
      .up("label")
      .hide()
      .insert({
        after:
          '<label><span class="cb2_' +
          (shipping_same_as_billing.checked ? "1" : "0") +
          '"></span>' +
          get_textnode_text(shipping_same_as_billing.up("label")) +
          "</label>",
      });
    $$(".address_table :input").each(function (element) {
      if (element.getAttribute("id").indexOf("shipping") > -1) {
        element.setStyle({ cursor: "not-allowed" });
        element.setAttribute("onclick", "notice_order_cannot_change();");
        if (element.nodeName === "INPUT") element.setAttribute("readonly", 1);
        else if (element.nodeName === "SELECT")
          isolate_selected_option(element);
      }
    });
  } else
    $("shipping_top_container").setAttribute(
      "onclick",
      "shipping_change_warning();"
    );
}

function shipping_change_warning() {
  if ($$("body")[0].getAttribute("data-shipping_change_warned") == 1) return;

  $$("body")[0].setAttribute("data-shipping_change_warned", 1);

  var isProjectOrder =
      typeof theOrder !== "undefined" &&
      typeof theOrder.isTypeProject === "function" &&
      theOrder.isTypeProject();
  var shippingWarningKey = isProjectOrder
      ? "LANG_THIS_ORDER_HAS_EITHER_BEEN_CONFIRMED_OR_PAID_ON_IF_YOU_ALTER_ANY_OF_THE_SHIPPING_INFO_NOW_THE_SHIP_PRICE"
      : "LANG_THIS_ORDER_HAS_EITHER_BEEN_VERIFIED_OR_PAID_ON_IF_YOU_ALTER_ANY_OF_THE_SHIPPING_INFO_NOW_THE_SHIP_PRICE";

  Modalbox.show(
    '<div class="notice"><p>' +
      get_language_translation(shippingWarningKey) +
      "</p></div>",
    {
      title: get_language_translation("LANG_WARNING_ON_CHANGING_SHIPPING"),
      width: 400,
      ok: true,
    }
  );
}

function setOnloadValues() {
  if (
    $("status") &&
    $("status").value != "bid" &&
    $("disc_percent") &&
    $("disc_percent").value &&
    "disc_percent".value != ""
  ) {
    var OD = $$(".onload_discount");
    for (var i = 0; i < OD.length; i++) {
      var onloadDisc = OD[i].name;
      document.getElementsByName(onloadDisc)[0].value = $("disc_percent").value;
    }
  }

  var D = $$(".current_status");
  for (var i = 0; i < D.length; i++) {
    var statusName = D[i].name;
    if (
      $("status") &&
      $("status").value &&
      document.getElementsByName(statusName) &&
      document.getElementsByName(statusName)[0]
    )
      document.getElementsByName(statusName)[0].value = $("status").value;
  }
}

// AKA presets
function load_order_level_settings() {
  const $container = am.$("#presets_temp_container");
  const order_id = am.$("[data-order-id]").first().data("order-id");
  const queryParams = new URLSearchParams(document.location.search);
  let dev;

  if (queryParams.get("dev") === "1") {
    dev = 1;
  }

  if ($container.length === 0) {
    toggle_folder_settings_button();
    console.info("presets disabled, skipping...");
    return;
  }

  if (!$container.children().length === 0) {
    console.info("presets already loaded, skipping...");
    return;
  }

  if (!theOrder?.isTypeProject()) {
    am.$.get("/ajax/orders/presets/", {order_id, dev}, function (ols) {
      $container.html(ols);
      $container.find("select.preset").each((_, e) => {
        get_product_image(e);
      });
      console.groupCollapsed('Order Presets');
      toggleSelectOptionsVisibilityByCompanyTags();
      console.groupEnd();
    });
  } else {
    console.info("Order is a project, skipping presets loading");
  }
  am.$.get(
    "/ajax/orders/presets/",
    { order_id, dev, folder_setting: true },
    function (ols) {
      window.folder_level_setting = {
        global: ols,
      };

      const folder_settings_data = presets_to_object(
        window.folder_level_setting.global
      );
      am.$(".saved_folder_settings").each((_, el) => {
        if (!el.value) {
          el.setAttribute("data-initialized", true);
          el.value = JSON.stringify(folder_settings_data);
        }
      });

      toggle_folder_settings_button();
      console.groupCollapsed('Folder Presets');
      toggleSelectOptionsVisibilityByCompanyTags();
      console.groupEnd();
    }
  );
}

function close_order_level_settings(skipScroll = false) {
  const $container = am
    .$("#ols_container")
    .siblings(".header")
    .trigger("click");
  if ($container.length > 0 && !skipScroll) {
    $container.get(0).scrollIntoView();
  }
}

function on_click_ols_update_current_folder(button) {
  const folder = button.closest(".order-folder");
  const applyToFutureFlag = folder.querySelector(
    "#presets .preset[name*=_apply_to_future]"
  );
  if (applyToFutureFlag) {
    applyToFutureFlag.value = true;
    if (window.folder_level_setting && window.folder_level_setting[folder.id]) {
      window.folder_level_setting[folder.id]["_apply_to_future"] = true;
    }
  }
  const savedPresets = folder.querySelector(".saved_folder_settings");
  if (savedPresets) {
    const savedPresetsData = JSON.parse(savedPresets.value);
    savedPresetsData["_apply_to_future"] = true;
    savedPresets.value = JSON.stringify(savedPresetsData);
  }
  on_click_ols_update_existing_products(folder.id);
}

function on_click_ols_update_new_products() {
  theOrder.save_presets();
  close_order_level_settings();

  show_snackbar({
    message:
      get_language_translation(
        "LANG_MSG_THESE_SETTINGS_WILL_BE_APPLIED_IN_FUTURE_PRODUCTS_YOU_ADD_TO_THIS_ORDER"
      ) + ".",
    type: "success",
  });
}

function on_click_ols_update_existing_products(folder_id = null, targetDiv = null, silentUpdate = false) {
  const $order_level_container = am.$("#ols_container");
  const $folder = am.$(`#${folder_id}`);
  const folder_exists = $folder.length > 0;

  if ($order_level_container || folder_exists) {
    const $presets = folder_exists
      ? $folder.find(".preset")
      : $order_level_container.find(".preset");
    const items = { product: [], component: [], supply: [] };

    $presets.each(function (index, el) {
      if (el.value !== "") {
        const attribute_name = el.getAttribute("data-attr");
        const norm_name = el.getAttribute("data-norm");
        const value = el.value;
        const baseContainer = folder_exists ? $folder.get(0) : document;
        const container = (targetDiv && document.getElementById(targetDiv)) || baseContainer;
        let selector =
          ':is(#productset, #componentset, #supplyset) [name$="[' + attribute_name + ']"]';

        if (norm_name && norm_name.trim() !== "" && norm_name !== attribute_name) {
          selector +=
            ', :is(#productset, #componentset, #supplyset) [name$="[' +
            norm_name +
            ']"]';
        }
        const fields = container.querySelectorAll(selector);
        fields.forEach(function (field) {
          const $field = am.$(field);
          const is_b2b = $field.closest(".product").data("rsource") !== "LOCAL";

          if (field.type === "checkbox") {
            $field.prop("checked", el.checked).change();
          } else {
            if ($field.is("select")) {
              let debug_message = "";
              const $options = $field.find("option");
              const preset_option_text = am
                .$(el)
                .find("option:selected")
                .text();
              const option_available =
                $field.find('option[value="' + value + '"]').length === 1;
              let fallback_value = value;

              if (!option_available) {
                fallback_value = null;
                debug_message += "No option with id " + value + " found.";

                $options.each((_, o) => {
                  if (o.text === preset_option_text) {
                    fallback_value = o.value;
                  }
                });

                if (fallback_value != null) {
                  debug_message +=
                    " Found option text '" +
                    preset_option_text +
                    "' with id: " +
                    fallback_value;
                } else {
                  debug_message +=
                    " No option with text '" + preset_option_text + "'found";
                }

                console.info(debug_message);
              }

              if (fallback_value != null) {
                $field.val(fallback_value).change();
              }
            } else {
              if (field.type !== "hidden") {
                $field.val(value).change();
              } else {
                console.log(
                  `Attribute ${attribute_name} not updated because is hidden`
                );
              }
            }
          }

          let $item = $field.closest("#componentset .product.component");
          if ($item.length === 1 && !items.component.includes($item.get(0))) {
            items.component.push($item.get(0));
          }

          $item = $field.closest("#productset .product");
          if ($item.length === 1 && !items.product.includes($item.get(0))) {
            items.product.push($item.get(0));
          }

          $item = $field.closest("#supplyset .product");
          if ($item.length === 1 && !items.supply.includes($item.get(0))) {
            items.supply.push($item.get(0));
          }
        });
      }
    });

    for (let type of Object.keys(items)) {
      items[type].forEach((element) => {
        order_item_changed(type, element);
        GUI.mark_watchform_as_dirty(element);
      });
    }

    if(silentUpdate)
      return;

    show_snackbar({
      message: folder_exists
        ? get_language_translation(
            "LANG_MSG_FOLDER_SETTINGS_APPLIED_SUCCESSFULLY"
          )
        : get_language_translation(
            "LANG_MSG_CHANGES_HAVE_BEEN_APPLIED_SUCCESSFULLY"
          ) + ".",
      type: "success",
    });

    if (folder_exists) {
      $folder.find(".order-folder-settings-button").click(); // close the folder settings
      $folder.get(0).scrollIntoView(); // scroll to the top of the folder
    } 
    else {
      const $olsContainer = am.$("#ols_container");
      if ($olsContainer.length > 0 && $olsContainer.is(':visible')) { // essentially check if the ols container is closed and if it is not, close it
        close_order_level_settings(true);
      }
    }
  }
}
am.$(function () {
  show_dev_tools();
  load_order_level_settings();
  // DEV-12318 QA: theOrder only exists on order pages, but this ready-handler runs
  // app-wide (js-core) — the bare reference threw a ReferenceError on every other
  // page (optional chaining doesn't guard an UNDECLARED identifier) and aborted the
  // rest of this callback. typeof-guard it.
  if (typeof theOrder !== 'undefined' && !theOrder?.isTypeProject()) {
    loadFolderCategorySelector();
  }
  check_folder_count();
  //toggle between span and input
  // am.$(document).on('click', '.order-folder-name-label', function (e) {
  // 	const $label = am.$(e.target);
  // 	const $editor = $label.parent().find('.order-folder-name-editor');
  // 	if ($editor.attr('disabled')) {
  // 		return;
  // 	}
  // 	$label.animate({maxWidth: 0, opacity: 0}, {queue: false});
  // 	$editor.attr('data-closed', false).animate({
  // 		maxWidth: '25rem',
  // 		opacity: 1
  // 	}, {queue: false}).fadeIn({queue: false}).select();
  // });

  //   function on_blur_editor(input) {
  //     const $input = am.$(input);
  //     $input
  //       .animate(
  //         {
  //           opacity: 0,
  //           maxWidth: 0,
  //           padding: 0,
  //           borderLeft: 0,
  //           borderRight: 0,
  //         },
  //         { queue: false }
  //       )
  //       .fadeOut({ queue: false });
  //     $input
  //       .parent()
  //       .find(".order-folder-name-label")
  //       .animate({ opacity: 1, maxWidth: "25rem" });
  //   }
  //   am.$(document).on("blur", ".order-folder-name-editor", (e) => {
  //     if (e.target.dataset.closed != "true") {
  //       on_blur_editor(e.target);
  //     }
  //   });
  //   am.$(document).on("keydown", ".order-folder-name-editor", (e) => {
  //     if (e.key === "Enter") {
  //       e.target.dataset.closed = true;
  //       on_blur_editor(e.target);
  //     }
  //   });
  //   am.$(document).on("change", ".order-folder-name-editor", function (e) {
  //     const $editor = am.$(e.target);
  //     let value = e.target.value ?? "";

  //     value = value.replace(/[^\w\d\s\/\-\.]/g, "");

  //     // fallback name when the name is filled with spaces
  //     if (value.trim().length === 0) {
  //       value = "Folder " + ($editor.closest(".order-folder").index() + 1);
  //     }

  //     $editor
  //       .val(value)
  //       .parent()
  //       .find(".order-folder-name-label")
  //       .text(value)
  //       .attr("data-dirty", true)
  //       .attr("title", value);
  //   });

  if (document.getElementById("add-folder")) {
    GUI.templatize("add-folder");
  }

  if (document.getElementById("add-room")) {
    GUI.templatize("add-room");
  }

  document.querySelectorAll(".discover-room").forEach((room) => {
    const hidden = room.querySelector(".saved_folder_settings");
    if (!hidden || !hidden.value) return;
    let data;
    try {
      data = JSON.parse(hidden.value);
    } catch (e) {
      return;
    }
    if (!data || typeof data !== "object") return;
    Object.entries(data).forEach(([attr, val]) => {
      const el = room.querySelector(
        '[name="folder_settings[' + attr + ']"]'
      );
      if (!el) return;
      if (el.type === "checkbox") {
        el.checked = val == 1 || val === true;
      } else {
        el.value = val;
      }
    });
  });

  init_folder_sortable();

  const $duplicate_order_button = am.$("#duplicate_order");
  const { type: userType } = get_user_info();
  const $onload_discount = am.$("#discount_onload");
  const order_discount =
    $onload_discount.length > 0 ? parseFloat($onload_discount.val()) : 0;

  if (userType === "employee" && order_discount !== 0) {
    $duplicate_order_button
      .attr("data-href", $duplicate_order_button.attr("href"))
      .attr("href", "javascript:void(0)")
      .on("click", async (e) => {
        e.preventDefault();

        const result = await ask_for_order_discount_removal();
        /**@type {string} clone_url */
        let clone_url = $duplicate_order_button.data("href");

        if (!result.dismiss) {
          const onClick = $duplicate_order_button.get(0).onclick;
          if (typeof onClick === "function") {
            onClick();
          }

          if (!result.confirm) {
            clone_url +=
              (!clone_url.includes("?") ? "?" : "") +
              "remove_order_level_discount=1";
          }

          location.href = clone_url;
        } else {
          re_enable_order_submission_buttons();
        }
      });
  }

  am.$(".order-folder").on("mouseenter", (e) => {
    const $folder = am.$(e.target).closest(".order-folder");

    const product_set = $folder.find("#productset").get(0);
    const component_set = $folder.find("#componentset").get(0);
    const supply_set = $folder.find("#supplyset").get(0);

    const onReorder = function (set) {
      return function () {
        renumber_line_ids(set);
      };
    };

    if (product_set) {
      Sortable.create(product_set, { tag: "div", handle: "dh", onUpdate: onReorder(product_set), });
    }

    if (component_set) {
      Sortable.create(component_set, { tag: "div", handle: "dh", onUpdate: onReorder(component_set), });
    }

    if (supply_set) {
      Sortable.create(supply_set, { tag: "div", handle: "dh" });
    }
  });

  window.renumber_line_ids = function () {
    if (typeof am === "undefined" || !am.$) return;
    if (!window._show_line_ids_enabled) return;

    var $scope = am.$("#productset, .c_productset");
    if (!$scope.length) return;

    $scope.find("input.qty").each(function () {
      var n = this.name || "";
      if (!n) return;
      if (n.indexOf("~id~") >= 0) return;
      if (/^pcomponents\[[^\]]+\]\[_qty\]$/.test(n)) return;
      var $qty = am.$(this);
      if ($qty.closest(".p_template").length) return;
      var $bottom = $qty.closest(".pao_bottom");
      if (!$bottom.length) return;
      if ($bottom.find(".line-id-display").length) return;
      var $span = am.$('<span class="line-id-display" style="margin: 0 4px;"></span>');
      var $shell = $qty.closest(".am-field");
      ($shell.length ? $shell : $qty).before($span);
      $span.after(document.createTextNode(" "));
    });

    var groupIdx = 0;
    $scope.find(".product").each(function () {
      var $product = am.$(this);
      if ($product.hasClass("component")) return;
      var $spans = $product.find(".line-id-display");
      if (!$spans.length) return;
      groupIdx++;
      $spans.each(function (rowIdx) {
        var $el = am.$(this);
        var lineNum = rowIdx + 1;
        var padded = (lineNum < 10 ? "0" : "") + lineNum;
        $el.attr("data-group-id", groupIdx);
        $el.attr("data-line-id", lineNum);
        $el.html(groupIdx + "&nbsp;" + padded);
      });
    });
  };

  (function () {
    var $section = am.$("#products_section");
    if (!$section.length) return;
    window._show_line_ids_enabled = $section.attr("data-show-line-ids") === "1";
    if (!window._show_line_ids_enabled) return;

    window.renumber_line_ids();

    if (!window.MutationObserver) return;
    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        observer.disconnect();
        window.renumber_line_ids();
        observer.observe($section.get(0), { childList: true, subtree: true });
      }, 50);
    });
    observer.observe($section.get(0), { childList: true, subtree: true });
  })();

  am.$(document).on(
    "change",
    ".order-folder-settings input, .order-folder-settings select",
    (e) => {
      const field = e.target;
      let field_name = field.name.match(/\[(\w*)\]/);

      if (field_name) {
        field_name = field_name[0].replace("[", "").replace("]", "");
      }

      const folder = field.closest(".order-folder, .discover-room");
      if (!folder) return;
      const saved_folder_settings = folder.querySelector(
        ".saved_folder_settings"
      );
      if (!saved_folder_settings) return;
      let folder_settings_data = {};

      try {
        folder_settings_data = JSON.parse(saved_folder_settings.value);
      } catch (err) {}

      if (!window.folder_level_setting) {
        folder_settings_data[field_name] =
          field.type === "checkbox" ? field.checked : field.value;
        saved_folder_settings.value = JSON.stringify(folder_settings_data);
        return;
      }

      if (!window.folder_level_setting[folder.id]) {
        if (Object.keys(folder_settings_data).length === 0) {
          //settings are empty / order is new (shouldn't reach here)
          folder_settings_data = presets_to_object(
            window.folder_level_setting.global
          );
          saved_folder_settings.value = JSON.stringify(folder_settings_data);
        }
        window.folder_level_setting[folder.id] = folder_settings_data;
      }
      window.folder_level_setting[folder.id][field_name] =
        field.type === "checkbox" ? field.checked : field.value;
      window.folder_level_setting[folder.id][`${folder.id}_dirty`] = true; //save the dirty state of the settings
      saved_folder_settings.value = JSON.stringify(
        window.folder_level_setting[folder.id]
      );

      // enable apply button when some modification is made
      const apply_button = folder.querySelector(".footer button");
      if (apply_button) apply_button.disabled = false;
    }
  );

  /**
   * We don't show/hide the html, instead we add/remove the HTML of the element to improve performance
   * this will benefit when there are a lot of folders and presets with selects with ton of options
   * */
  const onToggleFolderSetting = (e) => {
    const button = e.target
      .closest(".order-folder")
      .querySelector(".order-folder-settings-button");
    const isClosing = button.classList.contains("active"); // the folder settings is open and will be closed
    button.classList.toggle("active");

    const folder = button.closest(".order-folder");
    const folder_toggle = folder.querySelector(".order-folder-caret");

    // open the folder if closed and settings are opening
    if (!folder_toggle.classList.contains("close") && !isClosing) {
      folder_toggle.click();
    }

    const folder_settings_container = folder.querySelector(
      ".order-folder-settings"
    );
    const saved_folder_settings_field = folder_settings_container.querySelector(
      ".saved_folder_settings"
    );
    const folder_id = folder.id;
    let folder_settings_data = {};

    try {
      folder_settings_data = JSON.parse(saved_folder_settings_field.value);
    } catch (err) {}

    if (window.folder_level_setting && folder_settings_container) {
      if (!window.folder_level_setting[folder_id]) {
        if (Object.keys(folder_settings_data).length === 0) {
          //settings are empty / order is new
          folder_settings_data = presets_to_object(
            window.folder_level_setting.global
          );
          saved_folder_settings_field.value =
            JSON.stringify(folder_settings_data);
        }

        window.folder_level_setting[folder_id] = folder_settings_data;
      }

      const folder_settings = window.folder_level_setting.global;
      const settings_field = saved_folder_settings_field.outerHTML; //hidden input to store the folder settings

      const $folder_settings_container = am.$(folder_settings_container);

      if (isClosing) {
        $folder_settings_container.fadeOut({ queue: false }).slideUp({
          queue: false,
          complete: () => {
            folder_settings_container.innerHTML = settings_field;
          },
        });
      } else {
        folder_settings_container.innerHTML = folder_settings + settings_field;
        toggleSelectOptionsVisibilityByCompanyTags(folder_settings_container.querySelectorAll("select.preset"));
        setTimeout(() => {
          $folder_settings_container
            .slideDown({ queue: false })
            .fadeIn({ queue: false });
        }, 100);
      }

      // Once the HTML is loaded we set the values from the stored data in memory
      Object.entries(window.folder_level_setting[folder_id]).forEach(
        ([name, val]) => {
          const element = folder_settings_container.querySelector(
            `[name="folder_settings[${name}]"]`
          );

          if (!element) {
            return;
          }

          if (element.type === "checkbox") {
            element.checked = !!val;
          } else if (element.tagName === "SELECT") {
            element.value = val;
          } else {
            element.value = val;
          }

          if (typeof element.onchange === "function") {
            element.onchange();
          }
        }
      );

      // if the settings are dirty then enable the button
      if (window.folder_level_setting[folder_id][`${folder_id}_dirty`]) {
        const button =
          folder_settings_container.querySelector(`.footer button`);

        if (button) {
          button.disabled = false;
        }
      }
    }
  };

  am.$(document).on(
    "click",
    ".order-folder-settings-button",
    onToggleFolderSetting
  );
  am.$(document).on(
    "click",
    ".order-folder-settings-header button",
    onToggleFolderSetting
  );
  am.$(document).on(
    "keydown",
    ".price_override_editor .price_override",
    onPriceOverrideKeydown
  );
});

// convert the html to an object to store the presets
function presets_to_object(raw_html_presets) {
  const element = document.createElement("div");
  element.innerHTML = raw_html_presets;
  const presets = element.querySelectorAll(".preset");
  const data = {};

  presets.forEach((preset) => {
    const field_name = preset.dataset.attr;
    if (preset.type === "checkbox") {
      data[field_name] = preset.checked;
    } else {
      data[field_name] = preset.value;
    }
  });

  return data;
}

function toggle_folders(state) {
  // if (state === "expand") {
  //   am.$(".order-folder .order-folder-caret.open").click();
  //   am.$(".order-folder .order-folder-info").addClass("folder-opened");
  // }
  // if (state === "collapse") {
  //   am.$(".order-folder .order-folder-caret.close").click();
  //   am.$(".order-folder .order-folder-info").removeClass("folder-opened");
  // }

  am.$(".order-folder").each(function () {
    var elementId = am.$(this).attr("id");
    if (state === "expand") {
      amToggleSection(elementId, "open");
    } else {
      amToggleSection(elementId, "closed");
    }
  });
}


function amToggleSection(folderId, forceState, options) {
  var settings = am.$.extend(
    {
      folderClass: "order-folder",
      headerClass: "order-folder-header",
      contentClass: "order-folder-content",
      caretClass: "order-folder-caret",
      openCaretClass: "fa-angle-down",
      closedCaretClass: "fa-angle-up",
      folderInfo: "order-folder-info",
      animationDuration: 200,
    },
    options
  );

  var selector = folderId;
  if (!folderId.startsWith("folder_")) {
    selector = "#folder_" + folderId;
  }
  else{
    selector = "#" + folderId;
  }
  var $header = am.$(selector + " ." + settings.headerClass);
  var $content = am.$(selector + " ." + settings.contentClass);
  var $caret = am.$(selector + " ." + settings.caretClass);
  var $folder_info = am.$(selector + " ." + settings.folderInfo);

  $header.css("cursor", "pointer");
  function openFolder() {
    $content.slideDown(settings.animationDuration);
    $caret
      .removeClass(settings.closedCaretClass)
      .addClass(settings.openCaretClass);
    $folder_info.addClass("folder-opened");
  }

  function closeFolder() {
    $content.slideUp(settings.animationDuration);
    $caret
      .removeClass(settings.openCaretClass)
      .addClass(settings.closedCaretClass);
    $folder_info.removeClass("folder-opened");
  }
  if (forceState === "open") {
    openFolder();
  }
  else if (forceState === "closed") {
    closeFolder();
  }
  else {
    if ($folder_info.hasClass("folder-opened")) {
      closeFolder();
    } else {
      openFolder();
    }
  }
  let $scrollContainer = am.$("#content_column");
  updateControlsVisibility();
}

function on_add_product_click(element) {
  const $button = am.$(element);
  $button.closest(".order-folder-content").find("#new_product").show();
  $button.parent().hide();
}

function get_duplicates_of_folder(folder_name) {
  let existing_copies = 0;

  // Folder name copy, Folder name copy 1
  const regex = new RegExp(
    "^" +
      folder_name +
      " " +
      get_language_translation("LANG_COPY_LOWERCASE") +
      "\\s*\\d*$"
  );
  am.$(".order-folder-name-editor").each((index, e) => {
    if (regex.test(e.value)) {
      existing_copies++;
    }
  });
  return existing_copies;
}

function on_duplicate_folder(element, id) {
  const $original_folder = am.$(element).closest(".order-folder");
  const original_folder_name = $original_folder
    .find(".order-folder-name-editor")
    .val();

  GUI.copy_folder(
    $original_folder.get(0),
    "order_folders",
    id,
    (new_folder) => {
      const $new_folder = am.$(new_folder);
      const existing = get_duplicates_of_folder(original_folder_name);

      const new_folder_name =
        original_folder_name +
        " " +
        get_language_translation("LANG_COPY_LOWERCASE") +
        (existing > 0 ? " " + (existing + 1) : "");
         $new_folder
           .find(".order-folder-name-label")
           .text(new_folder_name)
           .removeAttr("data-dirty");
         $new_folder
           .find(".order-folder-name-editor")
           .val(new_folder_name)
           .attr("value", new_folder_name);
      $new_folder.get(0).scrollIntoView();
    }
  );

  toggle_delete_folder_button();
  init_folder_sortable();
  theOrder.update_folders_data();
  initializeTooltips();
  check_folder_count();
}

function on_add_folder() {
  GUI.enumerate("add-folder", "order_folders");

  const $folders = am.$(".order-folder");
  if ($folders.length > 0) {
    const $new_folder = $folders.last();
    // we remove the empty <div> parent to make all folders the same hierarchy
    $new_folder.parent().remove();
    am.$(".order_folders").append($new_folder);
    // Folder 1, 2, 3 (or Room 1, 2, 3 for project orders)
    const folder_label = (typeof theOrder !== "undefined" && theOrder?.isTypeProject && theOrder.isTypeProject())
      ? get_language_translation("LANG_ROOM")
      : get_language_translation("LANG_FOLDER");
    const new_folder_name = folder_label + " " + $folders.length;
    $new_folder.find(".order-folder-name-label").text(new_folder_name);
    $new_folder.find(".order-folder-name-editor").val(new_folder_name);

    $new_folder.get(0).scrollIntoView();
    //initialize the folder level settings
    if (window.folder_level_setting?.global) {
      const saved_folder_settings = $new_folder
        .get(0)
        .querySelector(".saved_folder_settings");
      const folder_settings_data = presets_to_object(
        window.folder_level_setting.global
      );
      saved_folder_settings.value = JSON.stringify(folder_settings_data);
    }

    window.add_folder_template_updated =
      window.add_folder_template_updated || false;
    const order_id = am.$("[data-order-id]").first().data("order-id");
    // load the categories when creating a new folder
    // if (false === window.add_folder_template_updated && !order_id) {
    // 	catsel(null, null, $new_folder.get(0)?.id);
    // }
    if (!theOrder?.isTypeProject()) {
      loadFolderCategorySelector();
    }
  }

  check_folder_count();
  init_product_quick_search_forms();
  toggle_delete_folder_button();
  init_folder_sortable();
  initializeTooltips();
  toggle_folder_settings_button();

  $new_folder_id = am.$(".order-folder").last()[0].dataset.folderId;

  amToggleSection($new_folder_id, "open");

  if (typeof theOrder !== "undefined" && theOrder?.isTypeProject && theOrder.isTypeProject()) {
    theOrder.ensureDefaultOtherCostRow();
  }
}

function refresh_discover_delete_buttons() {
  const container = document.getElementById("discover_rooms");
  if (!container) return;
  const rooms = container.querySelectorAll(".discover-room");
  const onlyOne = rooms.length <= 1;
  rooms.forEach((room) => {
    const btn = room.querySelector(".delete-folder-button");
    if (!btn) return;
    if (onlyOne) {
      btn.setAttribute("disabled", "disabled");
    } else {
      btn.removeAttribute("disabled");
    }
  });
  check_room_count();
}

function toggle_rooms(state) {
  am.$("#discover_rooms .discover-room").each(function () {
    const $room = am.$(this);
    const isOpen = $room
      .find(".order-folder-info")
      .first()
      .hasClass("folder-opened");
    if ((state === "expand" && !isOpen) || (state === "collapse" && isOpen)) {
      const caret = $room.find(".order-folder-caret").get(0);
      if (caret) caret.click();
    }
  });
  updateDiscoverControlsVisibility();
}

function check_room_count() {
  const container = document.getElementById("discover_rooms");
  if (!container) return;
  const roomCount = container.querySelectorAll(".discover-room").length;
  if (roomCount > 1) {
    am.$(".discover-toggle--new").removeClass("am-folder-toggle--only");
    am.$(".discover-toggle--collapse").fadeIn();
    am.$(".discover-toggle--expand").fadeIn();
    am.$(".discover-rooms-toggle--bottom").fadeIn();
  } else {
    am.$(".discover-toggle--new").addClass("am-folder-toggle--only");
    am.$(".discover-toggle--collapse").fadeOut();
    am.$(".discover-toggle--expand").fadeOut();
    am.$(".discover-rooms-toggle--bottom").fadeOut();
  }
  updateDiscoverControlsVisibility();
}

function updateDiscoverControlsVisibility() {
  const $controls = am.$(".discover-rooms-toggle");
  const $controlsb = am.$(".discover-rooms-toggle--bottom");
  const $scrollContainer = am.$("#content_column");

  if ($controls.length && $controlsb.length && $scrollContainer.length) {
    const $firstControl = $controls.eq(0);
    const $secondControl = $controlsb.eq(0);
    if ($firstControl.length && $secondControl.length) {
      const scrollTop = $scrollContainer.scrollTop();
      const containerHeight = $scrollContainer.height();
      const scrollBottom = scrollTop + containerHeight;

      const firstTop = $firstControl.position().top + scrollTop;
      const firstBottom = firstTop + $firstControl.outerHeight();
      const secondTop = $secondControl.position().top + scrollTop;
      const secondBottom = secondTop + $secondControl.outerHeight();

      const firstInView = firstBottom > scrollTop && firstTop < scrollBottom;
      const secondInView = secondBottom > scrollTop && secondTop < scrollBottom;

      if (!firstInView && secondInView) {
        $firstControl.css({ visibility: "hidden", opacity: "0" });
        $secondControl.css({ visibility: "visible", opacity: "1" }).show();
      } else {
        $firstControl.css({ visibility: "visible", opacity: "1" }).show();
        $secondControl.css({ visibility: "hidden", opacity: "0" });
      }
    }
  }
}

function on_add_room() {
  const container = document.getElementById("discover_rooms");
  if (!container) return;

  const templateHtml =
    (window.GUI && GUI.templates && GUI.templates["add-room"]) || "";
  if (!templateHtml) return;

  const newId =
    "n" +
    (typeof GUI !== "undefined" && typeof GUI.get_num === "function"
      ? GUI.get_num()
      : Date.now());
  const html = templateHtml.replace(/~id~/g, newId);

  const wrapper = document.createElement("div");
  wrapper.innerHTML = html;
  const outerWrapper = wrapper.firstElementChild;
  const newRoom = outerWrapper && outerWrapper.querySelector(".discover-room");
  if (!newRoom) return;

  container.appendChild(newRoom);

  const roomCount = container.querySelectorAll(".discover-room").length;
  const editor = newRoom.querySelector(".order-folder-name-editor");
  if (editor) editor.value = "Room " + roomCount;

  const newInfo = newRoom.querySelector(".order-folder-info");
  const newCaret = newRoom.querySelector(".order-folder-caret");
  if (newCaret && newInfo && !newInfo.classList.contains("folder-opened")) {
    newCaret.click();
  }

  refresh_discover_delete_buttons();
  newRoom.scrollIntoView();
}

async function room_can_delete(folderId) {
  if (!/^\d+$/.test(String(folderId))) {
    return { ok: true };
  }
  const orderEl = document.getElementById("jobs");
  const orderId = orderEl ? orderEl.getAttribute("data-order_id") : null;
  if (!orderId) {
    return { ok: true };
  }
  const base =
    typeof SITE_BASE !== "undefined"
      ? SITE_BASE
      : typeof web_root !== "undefined"
      ? web_root + "/"
      : "/";
  try {
    const fd = new FormData();
    fd.append("order_id", orderId);
    fd.append("folder_id", folderId);
    const resp = await fetch(base + "ajax/order_rooms/can_delete/", {
      method: "POST",
      body: fd,
      credentials: "same-origin",
    });
    const data = await resp.json();
    if (data && data.ok) return { ok: true };
    return { ok: false, message: (data && data.message) || "" };
  } catch (e) {
    return { ok: true };
  }
}

async function on_delete_room(folderId) {
  const check = await room_can_delete(folderId);
  if (!check.ok) {
    if (check.message) alert(check.message);
    return;
  }
  const $room = am.$('#discover_rooms > [data-folder-id="' + folderId + '"]');
  if ($room.length) $room.remove();
  refresh_discover_delete_buttons();
}

function on_duplicate_room(button, folderId) {
  const container = document.getElementById("discover_rooms");
  if (!container) return;

  const sourceRoom = container.querySelector(
    '[data-folder-id="' + folderId + '"]'
  );
  if (!sourceRoom) return;

  const newId =
    "n" +
    (typeof GUI !== "undefined" && typeof GUI.get_num === "function"
      ? GUI.get_num()
      : Date.now());

  const oldId = String(folderId);
  const newRoom = sourceRoom.cloneNode(true);

  const escapeRegex = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const folderArrayPattern = new RegExp(
    "folders\\[" + escapeRegex(oldId) + "\\]",
    "g"
  );
  const domIdPattern = new RegExp(
    "folder_" + escapeRegex(oldId) + "(?![\\w])",
    "g"
  );

  const rewriteAttributes = (el) => {
    if (el.nodeType !== 1) return;
    if (el.getAttribute("data-folder-id") === oldId) {
      el.setAttribute("data-folder-id", newId);
    }
    Array.from(el.attributes || []).forEach((attr) => {
      if (attr.name === "data-folder-id") return;
      let v = attr.value;
      if (!v) return;
      let changed = false;
      if (v.indexOf("folders[" + oldId + "]") !== -1) {
        v = v.replace(folderArrayPattern, "folders[" + newId + "]");
        changed = true;
      }
      if (v.indexOf("folder_" + oldId) !== -1) {
        v = v.replace(domIdPattern, "folder_" + newId);
        changed = true;
      }
      if (changed) el.setAttribute(attr.name, v);
    });
    Array.from(el.children).forEach(rewriteAttributes);
  };
  rewriteAttributes(newRoom);

  newRoom.querySelectorAll(".delete-folder-button").forEach((btn) => {
    btn.setAttribute("onclick", "on_delete_room('" + newId + "')");
  });
  Array.from(newRoom.querySelectorAll("button")).forEach((btn) => {
    const oc = btn.getAttribute("onclick");
    if (oc && oc.indexOf("on_duplicate_room(") !== -1) {
      btn.setAttribute("onclick", "on_duplicate_room(this, '" + newId + "')");
    }
  });

  const srcControls = sourceRoom.querySelectorAll("input, select, textarea");
  const dstControls = newRoom.querySelectorAll("input, select, textarea");
  for (let i = 0; i < srcControls.length && i < dstControls.length; i++) {
    const src = srcControls[i];
    const dst = dstControls[i];
    if (src.type === "checkbox" || src.type === "radio") {
      dst.checked = src.checked;
    } else {
      dst.value = src.value;
    }
  }

  const sourceEditor = sourceRoom.querySelector(".order-folder-name-editor");
  const sourceName = sourceEditor ? sourceEditor.value || "" : "";
  const copyWord =
    typeof get_language_translation === "function"
      ? get_language_translation("LANG_COPY_LOWERCASE")
      : "copy";
  const copyRegex = new RegExp(
    "^" + escapeRegex(sourceName) + " " + escapeRegex(copyWord) + "\\s*\\d*$"
  );
  let existingCopies = 0;
  container.querySelectorAll(".order-folder-name-editor").forEach((e) => {
    if (copyRegex.test(e.value)) existingCopies++;
  });
  const newName =
    sourceName +
    " " +
    copyWord +
    (existingCopies > 0 ? " " + (existingCopies + 1) : "");

  const editor = newRoom.querySelector(".order-folder-name-editor");
  if (editor) {
    editor.value = newName;
    editor.setAttribute("value", newName);
  }

  const addRoomTplHtml =
    (window.GUI && GUI.templates && GUI.templates["add-room"]) || "";
  const clonedFilesInstance = newRoom.querySelector(".am-design-files-instance");
  if (addRoomTplHtml && clonedFilesInstance && clonedFilesInstance.parentNode) {
    const tplWrap = document.createElement("div");
    tplWrap.innerHTML = addRoomTplHtml.replace(/~id~/g, newId);
    const pendingInstance = tplWrap.querySelector(".am-design-files-instance");
    if (pendingInstance) {
      pendingInstance.setAttribute("data-room-id", newId);
      clonedFilesInstance.parentNode.replaceChild(pendingInstance, clonedFilesInstance);
    }
  }

  container.appendChild(newRoom);
  refresh_discover_delete_buttons();
}

function handleControlClick() {
  updateControlsVisibility();
}
function check_folder_count() {
  var foldercnt = am.$(".order-folder:not([id^='folder_n~'])").length;

  if (foldercnt > 1) {
    am.$(".am-folder-toggle--new").removeClass("am-folder-toggle--only");
    am.$(".am-folder-toggle--collapse").fadeIn();
    am.$(".am-folder-toggle--expand").fadeIn();
    am.$(".am-folder-toggle-container--bottom").fadeIn();
  } else {
    am.$(".am-folder-toggle--new").addClass("am-folder-toggle--only");
    am.$(".am-folder-toggle--collapse").fadeOut();
    am.$(".am-folder-toggle--expand").fadeOut();
    am.$(".am-folder-toggle-container--bottom").fadeOut();
  }
}

async function on_delete_folder(id) {
  const number_of_folders = am.$(".order-folder").length;
  if (number_of_folders === 1) {
    alert(
      get_language_translation("LANG_MSG_YOU_MUST_HAVE_AT_LEAST_ONE_FOLDER") +
        "."
    );
    return;
  }

  const $folder = am.$("#" + id);

  if (
    typeof theOrder !== "undefined" &&
    theOrder?.isTypeProject &&
    theOrder.isTypeProject()
  ) {
    const check = await room_can_delete($folder.attr("data-folder-id"));
    if (!check.ok) {
      if (check.message) alert(check.message);
      return;
    }
  }

  const folder_is_empty =
    $folder.find("#productset, #componentset, #supplyset").children().length ===
    0;
  let result = { confirm: false };

  if (!folder_is_empty) {
    result = await show_dialog({
      text: get_language_translation(
        "LANG_MSG_DELETING_THIS_FOLDER_WILL_ALSO_DELETE_ALL_ITS_PRODUCTS"
      ),
      icon: "fa fa-trash am-text-danger",
      iconStyle: "font-size: 1.725rem",
      primaryButton: {
        text: get_language_translation("LANG_LABEL_DELETE"),
        class: "am-btn am-btn--filled am-btn--danger",
        style: "flex:1",
      },
      cancelButton: {
        text: get_language_translation("LANG_BTN_CANCEL"),
        show: true,
        class: "am-btn am-btn--outlined",
        style: "flex:1",
      },
      width: 480,
    });
  }

  if (folder_is_empty || result.confirm) {
    $folder.remove();
    show_snackbar({
      message: get_language_translation("LANG_MSG_FOLDER_REMOVED_SUCCESSFULLY"),
      type: "success",
      show_close: false,
    });
    theOrder
      .invalidate("items")
      .invalidate("total")
      .invalidate("tax")
      .invalidate("shipping")
      .process();
    toggle_delete_folder_button();
    init_folder_sortable();
    check_folder_count();
  }
}

function toggle_delete_folder_button() {
  const number_of_folders = am.$(".order-folder").length;
  am.$(".order-folder")
    .find(".am-custom-dropdown .delete-folder-button")
    .prop("disabled", number_of_folders === 1);
}

function toggle_folder_settings_button() {
  const folder_settings_data = presets_to_object(
    window.folder_level_setting?.global
  );
  const presets_exist = Object.keys(folder_settings_data).length > 0;
  document
    .querySelectorAll(".order-folder-settings-button")
    .forEach((button) => {
      button.classList.toggle("d-none", !presets_exist);
    });
}

function init_folder_sortable() {
  if (am.$("#order_folders").length > 0) {
    Sortable.create("order_folders", {
      tag: "div",
      handle: "dh",
    });
  }
}

function debounce_mult(fn, wait = 500) {
  let t = null, lastArgs, lastThis;
  function invoke() {
    t = null;
    fn.apply(lastThis, lastArgs);
    lastArgs = lastThis = null;
  }
  function debounced(...args) {
    lastArgs = args;
    lastThis = this;
    if (t) clearTimeout(t);
    t = setTimeout(invoke, wait);
  }
  debounced.cancel = () => { if (t) { clearTimeout(t); t = null; } };
  debounced.flush  = () => { if (t) { clearTimeout(t); invoke(); } };
  return debounced;
}
async function runOrderProcess() {
  await theOrder
    .invalidate('items')
    .invalidate('total')
    .invalidate('subtotal')
    .process();
}
const processDebounced = debounce_mult(() => {
  runOrderProcess().catch(console.error);
}, 800);

function on_copy_product(element) {
  const originalIsDirty = theOrder.productIsDirty(element);
  GUI.copy(element, 1, undefined, ($new_element) => {
    $new_element
      .find("[data-litebox_initialized]")
      .removeAttr("data-litebox_initialized");
    $new_element.addClass("stale");
    if (!$new_element.attr("id")) {
      $new_element.attr("id", crypto.randomUUID());
    }

    if (!originalIsDirty) {
      /**@type {HTMLDivElement}*/
      const newElement = $new_element.get(0);
      newElement.classList.remove('isDirty');
      newElement.querySelectorAll('.is_dirty').forEach((el) => {
        el.value = false;
      });
    }
  });
	processDebounced();
}

/**@param {KeyboardEvent} e*/
const onPriceOverrideKeydown = (e) => {
  const allowedCharacters = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    ".",
    "Backspace",
    "Tab",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "-",
  ].map((x) => x.toString());

  if (!allowedCharacters.includes(e.key)) {
    e.preventDefault();
  }
};

function updateControlsVisibility() {
  const $controls = am.$(".am-folder-toggle-container");
  const $controlsb = am.$(".am-folder-toggle-container--bottom");
  let $scrollContainer = am.$("#content_column");

  if (($controls.length + $controlsb.length) === 2 && $scrollContainer.length) {
    const $firstControl = $controls.eq(0);
    const $secondControl = $controlsb.eq(0);

    // Check if both $firstControl and $secondControl are defined
    if ($firstControl.length && $secondControl.length) {
      // Get scroll position and heights
      const scrollTop = $scrollContainer.scrollTop();
      const containerHeight = $scrollContainer.height();
      const scrollBottom = scrollTop + containerHeight;

      // Get control positions relative to the scrollable container
      const firstTop = $firstControl.position().top + scrollTop;
      const firstBottom = firstTop + $firstControl.outerHeight();
      const secondTop = $secondControl.position().top + scrollTop;
      const secondBottom = secondTop + $secondControl.outerHeight();

      // Check what's visible
      const firstInView = firstBottom > scrollTop && firstTop < scrollBottom;
      const secondInView = secondBottom > scrollTop && secondTop < scrollBottom;

      // Use visibility instead of display to prevent layout jumps
      if (firstInView && secondInView) {
        $firstControl.css({ visibility: "visible", opacity: "1" }).show();
        $secondControl.css({ visibility: "hidden", opacity: "0" });
      }
      else if (firstInView && !secondInView) {
        $firstControl.css({ visibility: "visible", opacity: "1" }).show();
        $secondControl.css({ visibility: "hidden", opacity: "0" });
      }
      else if (!firstInView && secondInView) {
        $firstControl.css({ visibility: "hidden", opacity: "0" });
        $secondControl.css({ visibility: "visible", opacity: "1" }).show();
      }
    }
  }
}

am.$(document).ready(function () {
  // Throttle with requestAnimationFrame for smooth scrolling
  let ticking = false;
  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(updateControlsVisibility);
      ticking = true;
      setTimeout(() => {
        ticking = false;
      }, 100); // Reset after 100ms
    }
  }

  // Initial check
  updateControlsVisibility();

  // Bind with throttling - removed the () parentheses
  am.$("#content_column").on("scroll", requestTick);
  am.$(window).on("resize", requestTick);
});

am.$(document).ready(function () {
  if (!document.getElementById("discover_rooms")) return;

  check_room_count();
  updateDiscoverControlsVisibility();

  let discoverTicking = false;
  function requestDiscoverTick() {
    if (!discoverTicking) {
      window.requestAnimationFrame(updateDiscoverControlsVisibility);
      discoverTicking = true;
      setTimeout(() => {
        discoverTicking = false;
      }, 100);
    }
  }

  am.$("#content_column").on("scroll", requestDiscoverTick);
  am.$(window).on("resize", requestDiscoverTick);

  //TODO: Temporary fix for: https://allmoxy.atlassian.net/browse/DEV-12935
  document.querySelectorAll(".discover-room-settings select.preset").forEach(e => {
    get_product_image(e);
  });
});

function total_order_weight() {
  let total_weight = 0;
  const orderIsBid = theOrder?.getOrderStatus() === ORDER_STATUS_BID;

  // products
  am.$("#productset .product .line_items .prod_weight").each(function () {
    let value = parseFloat(am.$(this).val());
    if (!isNaN(value)) {
      total_weight += value;
    }
  });

  // supplies
  document.querySelectorAll("#supplyset .supply").forEach(function ($supply) {
    let value = parseFloat($supply.querySelector(".prod_weight")?.value || 0);
    if (!isNaN(value)) {
      total_weight += value;
    }
  });


  document.querySelectorAll(".component").forEach(function ($component) {
    const $componentQtyInput = $component.querySelector("input[name*=\"pcomponents[\"][name$=\"[_qty]\"]");
    const componentQty = parseFloat($componentQtyInput?.value);
    const isDirty = theOrder?.productIsDirty($component) ?? false;

    // Find all table rows within the line_items table
    $component.querySelectorAll(".line_items tbody tr").forEach(function ($row) {
      const value = parseFloat($row.querySelector(".prod_weight")?.value);
      if (!isNaN(value) && !isNaN(componentQty)) {
        /* For components, it's not necessary to multiply by the quantity because the weight is already
        * equals to individual weight * item qty * component qty
        */
        total_weight += (value * ((orderIsBid || isDirty) ? componentQty : 1));
      }
    });

    //supplies
    $component.querySelectorAll(".supply").forEach(function ($row) {
      const value = parseFloat($row.querySelector(".prod_weight")?.value);
      if (!isNaN(value)) {
        // for some reason supplies weight is not being multiplied by the component quantity.
        total_weight += value * componentQty;
      }
    });
  });

  /**
   * Since .toFixed() doesn't handle the last digit correctly we add some decimals to round properly
   * eg:
   *      -3.465.toFixed(2) = -3.46 ❌
   * but
   *      -3.4650000000000001.toFixed(2) = -3.47 ✅
   *
   * This only applies for decimal numbers, not integers
   * */
  const decimalPlaces = 2;
  if (!Number.isInteger(cur2num(total_weight))) {
    const fixedAmount = total_weight + "0000000000001";
    if (
        cur2num(fixedAmount).toFixed(decimalPlaces) !==
        cur2num(total_weight).toFixed(decimalPlaces)
    ) {
      total_weight = cur2num(fixedAmount);
    }
  }

  am.$("#total_weight_field").text(total_weight.toFixed(decimalPlaces));
  sync_order_weight_row(total_weight);
}

function sync_order_weight_row(value) {
  var $row = am.$(".order_weight_total");
  if (!$row.length) return;
  var amount = parseFloat(String(value).replace(/[^0-9.-]/g, ""));
  $row.prop("hidden", !(amount > 0));
}

am.$(document).on('change input', '.prod_weight', function() {
    total_order_weight();
});

/**
 * @typedef {Object} OtherCost
 * @property {string} description
 * @property {number} quantity
 * @property {number} price
 *
 * @param {Object} data
 * */
function createOtherCostRow(data) {
  const {id, description, quantity, price, folderId, exportClassId, isTaxable} = data;

  // DEV-12385: classic 20px field shell (styles/scss/m3/_field.scss). The __box span is
  // REQUIRED — the input carries no border under this construction; the empty __gap stays
  // (the 20px classic has no floating label).
  const wrapClassicField = ($input) => {
    const $shell = document.createElement("span");
    $shell.classList.add("am-field", "am-field--outlined", "am-field--classic");
    const $box = document.createElement("span");
    $box.classList.add("am-field__box");
    $box.setAttribute("aria-hidden", "true");
    const $gap = document.createElement("i");
    $gap.classList.add("am-field__gap");
    $box.append(document.createElement("i"), $gap, document.createElement("i"));
    $shell.append($input, $box);
    return $shell;
  };

  const $row = document.createElement("tr");
  let $td = document.createElement("td");

  const $qty = document.createElement("input");
  $qty.type = "number";
  $qty.value = Number.isNaN(parseInt(quantity)) ? "" : Number(quantity).toString();
  $qty.name = `cost[${id}][qty]`;
  $qty.classList.add("qty", "am-field__input");
  $qty.addEventListener("change", () => {
    const qty = Number($qty.value);
    if (qty > 0) {
      $qty.value = parseInt(qty.toString()).toString();
    } else {
      $qty.value = '';
    }
  });
  $qty.addEventListener("focusin", () => $qty.select());
  $td.append(wrapClassicField($qty));
  $row.append($td);

  $td = document.createElement("td");
  const $description = document.createElement("input");
  $description.type = "text";
  $description.value = description;
  $description.name = `cost[${id}][name]`;
  $description.classList.add("text-start", "description", "am-field__input");
  $td.append(wrapClassicField($description));
  $row.append($td);

  $td = document.createElement("td");
  const $price = document.createElement("input");
  $price.type = "number";
  $price.value = Number.isNaN(parseFloat(price)) ? "" : Number(price).toFixed(2);
  $price.name = `cost[${id}][price]`;
  $price.classList.add("price", "am-field__input");
  $price.addEventListener("change", () => {
    const price = Number($price.value);
    if (price > 0) {
      $price.value = price.toFixed(2);
    } else {
      $price.value = '';
    }
  });
  $price.addEventListener('focusin', () => $price.select());

  const $currency = document.createElement("span");
  $currency.innerText = get_currency_symbol();
  $currency.classList.add("me-1");

  const $div = document.createElement("div");
  $div.classList.add("d-inline-flex", "align-items-center", "w-100");
  $div.append($currency);
  $div.append(wrapClassicField($price));
  $td.append($div);
  $row.append($td);

  $td = document.createElement("td");
  const $exportClass = document.createElement("select");
  $exportClass.value = Number.isNaN(parseInt(exportClassId)) ? "" : Number(exportClassId);
  $exportClass.name = `cost[${id}][export_class_id]`;

  $exportClass.add(new Option("-- " + get_language_translation("LANG_OPT_SELECT_ONE") + " --", "", true));
  (window.projectLineItemsExportClasses|| []).forEach(exportClass => {
    $exportClass.add(new Option(exportClass.name, exportClass.id, false, exportClass.id === exportClassId));
  })
  $exportClass.classList.add("am-field__input");
  $td.append(wrapClassicField($exportClass));
  $row.append($td);

  $td = document.createElement("td");
  const $isTaxExempt = document.createElement("input");
  $isTaxExempt.type = "checkbox";
  $isTaxExempt.value = "1";
  $isTaxExempt.checked = !isTaxable;
  if (!isTaxable) { // Required for cloning, the js is weird.
    $isTaxExempt.setAttribute("checked", "checked");
  }

  $isTaxExempt.name = `cost[${id}][is_taxable]`;
  $isTaxExempt.classList.add("is_taxable");
  $td.append($isTaxExempt);
  $row.append($td);

  $td = document.createElement("td");
  const $subtotal = document.createElement("span");
  $subtotal.classList.add("item_subtotal");
  $td.append($subtotal);
  $row.append($td);

  const totalListener = () => {
    if (theOrder?.isTypeProject?.() && theOrder.applyProjectLineDiscountDisplay) {
      theOrder.applyProjectLineDiscountDisplay();
      return;
    }

    const decimalPlaces = 2;
    let total = (Number($qty.value) * Number($price.value)).toFixed(decimalPlaces);

    if (!Number.isInteger(cur2num(total))) {
      const fixedAmount = total + "0000000000001";
      if (cur2num(fixedAmount).toFixed(decimalPlaces) !== cur2num(total).toFixed(decimalPlaces)) {
        total = fixedAmount;
      }
    }
    $subtotal.textContent = CurrencyFormatted(total);
    theOrder?.update_folders_subtotal();
  };
  $price.addEventListener("change", totalListener);
  $qty.addEventListener("change", totalListener);
  totalListener();


  const invalidateTotals = debounce(() => {
    if ($qty.value && $price.value) {
      theOrder?.invalidate('shipping').invalidate("subtotal").process();
    }
  });
  $isTaxExempt.addEventListener("change", invalidateTotals);
  $price.addEventListener("change", invalidateTotals);
  $qty.addEventListener("change", invalidateTotals);


  $td = document.createElement("td");
  // DEV-13091: the certified row-action button (icon, danger tint) instead of a Bootstrap
  // utility button. Bootstrap's text-muted is a fixed dark gray with !important, so the
  // Font Awesome trash was dark-on-dark in dark mode; the part takes the error role ink
  // in both themes and the house delete glyph at the 20px rung (m3/_table.scss).
  const $deleteBtn = document.createElement("button");
  $deleteBtn.type = "button";
  $deleteBtn.className = "am-table__actionbtn am-table__actionbtn--icon am-table__actionbtn--danger";
  $deleteBtn.setAttribute("aria-label", get_language_translation("LANG_REMOVE"));
  $deleteBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>';
  $deleteBtn.addEventListener("click", () => {
    $row.remove();

    theOrder?.invalidate('tax').process();
    theOrder?.update_folders_subtotal();
    theOrder?.calculate_subtotal();
  });
  $td.append($deleteBtn);

  const $folderId = document.createElement("input");
  $folderId.type = "hidden";
  $folderId.value = folderId;
  $folderId.name = `cost[${id}][folder_id]`;
  $folderId.classList.add("folder_id");
  $td.append($folderId);

  $row.append($td);

  return $row;
}

function addOtherCostRow(folderId, data, isDefaultRow) {
  const $table = document.querySelector("#folder_" + folderId + " .project-line-items table");
  const lineData = data || {
    id: "n_" + (Date.now()),
    description: "",
    quantity: '',
    price: '',
    folderId: folderId,
    exportClassId: null,
    isTaxable: true,
  };
  const $row = createOtherCostRow(lineData);
  if (isDefaultRow) {
    $row.dataset.defaultRow = "1";
  }
  $table?.querySelector("tbody")?.append($row);

  const headerCount = $table?.querySelectorAll("thead th").length || 0;
  const tdCount = $row.querySelectorAll("td").length;
  if (tdCount > headerCount) {
    const $qty = $row.querySelector(".qty");
    if ($qty) {
      $qty.closest("td").style.display = "none";
      if (!$qty.value) {
        $qty.value = "1";
      }
    }
  }
}

// DEV-12923: moved here from formula.js (now catalog/settings-only, js-catalog-edit). Sole
// consumer is partials/product_form_attribute_form.tpl under {if $debug_hidden}, which only
// renders where js-orders loads.
function toggle_invalid_option_outline(el)
{
	if(el.options[el.selectedIndex].hasClassName('debug_invalid_option'))
		el.setStyle({ 'border-color': 'red', 'outline': 'red solid 10px' });
	else
		el.setStyle({ 'border-color': 'unset', 'outline': 'unset' });
}
